/*! @tailwindplus/elements v1.0.20 | Proprietary License | https://tailwindcss.com/plus/license */ var $46bff87bcc38d89a$var$Pn = Object.defineProperty;
var $46bff87bcc38d89a$var$To = (e)=>{
    throw TypeError(e);
};
var $46bff87bcc38d89a$var$kn = (e, o, t)=>o in e ? $46bff87bcc38d89a$var$Pn(e, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[o] = t;
var $46bff87bcc38d89a$var$M = (e, o, t)=>$46bff87bcc38d89a$var$kn(e, typeof o != "symbol" ? o + "" : o, t), $46bff87bcc38d89a$var$Ct = (e, o, t)=>o.has(e) || $46bff87bcc38d89a$var$To("Cannot " + t);
var $46bff87bcc38d89a$var$d = (e, o, t)=>($46bff87bcc38d89a$var$Ct(e, o, "read from private field"), t ? t.call(e) : o.get(e)), $46bff87bcc38d89a$var$L = (e, o, t)=>o.has(e) ? $46bff87bcc38d89a$var$To("Cannot add the same private member more than once") : o instanceof WeakSet ? o.add(e) : o.set(e, t), $46bff87bcc38d89a$var$I = (e, o, t, n)=>($46bff87bcc38d89a$var$Ct(e, o, "write to private field"), n ? n.call(e, t) : o.set(e, t), t), $46bff87bcc38d89a$var$H = (e, o, t)=>($46bff87bcc38d89a$var$Ct(e, o, "access private method"), t);
if (typeof globalThis.window < "u") {
    let e = !1;
    document.addEventListener("submit", (o)=>{
        if (e) {
            e = !1;
            return;
        }
        let t = o.target;
        if (t && t.method === "dialog") {
            let n = t.closest("el-dialog");
            if (!n || !("beforeClose" in n)) return;
            let r = n.beforeClose();
            if (r === !0 || (o.preventDefault(), o.stopImmediatePropagation(), r === !1)) return;
            r.then((i)=>{
                i && (e = !0, t.dispatchEvent(o));
            }).catch(console.error);
        }
    }, !0);
}
var $46bff87bcc38d89a$var$at = class extends Event {
    constructor(o, { oldState: t = "", newState: n = "", ...r } = {}){
        super(o, r);
        $46bff87bcc38d89a$var$M(this, "oldState");
        $46bff87bcc38d89a$var$M(this, "newState");
        this.oldState = String(t || ""), this.newState = String(n || "");
    }
}, $46bff87bcc38d89a$var$So = new WeakMap;
function $46bff87bcc38d89a$var$Do(e, o, t) {
    $46bff87bcc38d89a$var$So.set(e, setTimeout(()=>{
        $46bff87bcc38d89a$var$So.has(e) && e.dispatchEvent(new $46bff87bcc38d89a$var$at("toggle", {
            cancelable: !1,
            oldState: o,
            newState: t
        }));
    }, 0));
}
var $46bff87bcc38d89a$var$Nt = globalThis.ShadowRoot || function() {}, $46bff87bcc38d89a$var$On = globalThis.HTMLDialogElement || function() {}, $46bff87bcc38d89a$var$rt = new WeakMap, $46bff87bcc38d89a$var$X = new WeakMap, $46bff87bcc38d89a$var$q = new WeakMap, $46bff87bcc38d89a$var$xe = new WeakMap;
function $46bff87bcc38d89a$var$it(e) {
    return $46bff87bcc38d89a$var$xe.get(e) || "hidden";
}
var $46bff87bcc38d89a$var$st = new WeakMap;
function $46bff87bcc38d89a$var$qe(e) {
    return [
        ...e
    ].pop();
}
function $46bff87bcc38d89a$var$Cn(e) {
    let o = e.popoverTargetElement;
    if (!(o instanceof HTMLElement)) return;
    let t = $46bff87bcc38d89a$var$it(o);
    e.popoverTargetAction === "show" && t === "showing" || e.popoverTargetAction === "hide" && t === "hidden" || (t === "showing" ? $46bff87bcc38d89a$var$Se(o, !0, !0) : $46bff87bcc38d89a$var$pe(o, !1) && ($46bff87bcc38d89a$var$st.set(o, e), $46bff87bcc38d89a$var$Rt(o)));
}
function $46bff87bcc38d89a$var$pe(e, o) {
    return !(e.popover !== "auto" && e.popover !== "manual" && e.popover !== "hint" || !e.isConnected || o && $46bff87bcc38d89a$var$it(e) !== "showing" || !o && $46bff87bcc38d89a$var$it(e) !== "hidden" || e instanceof $46bff87bcc38d89a$var$On && e.hasAttribute("open") || document.fullscreenElement === e);
}
function $46bff87bcc38d89a$var$Lo(e) {
    if (!e) return 0;
    let o = $46bff87bcc38d89a$var$X.get(document) || new Set, t = $46bff87bcc38d89a$var$q.get(document) || new Set;
    return t.has(e) ? [
        ...t
    ].indexOf(e) + o.size + 1 : o.has(e) ? [
        ...o
    ].indexOf(e) + 1 : 0;
}
function $46bff87bcc38d89a$var$Dn(e) {
    let o = $46bff87bcc38d89a$var$Mo(e), t = $46bff87bcc38d89a$var$Mn(e);
    return $46bff87bcc38d89a$var$Lo(o) > $46bff87bcc38d89a$var$Lo(t) ? o : t;
}
function $46bff87bcc38d89a$var$Ve(e) {
    let o, t = $46bff87bcc38d89a$var$q.get(e) || new Set, n = $46bff87bcc38d89a$var$X.get(e) || new Set, r = t.size > 0 ? t : n.size > 0 ? n : null;
    return r ? (o = $46bff87bcc38d89a$var$qe(r), o.isConnected ? o : (r.delete(o), $46bff87bcc38d89a$var$Ve(e))) : null;
}
function $46bff87bcc38d89a$var$Io(e) {
    for (let o of e || [])if (!o.isConnected) e.delete(o);
    else return o;
    return null;
}
function $46bff87bcc38d89a$var$Te(e) {
    return typeof e.getRootNode == "function" ? e.getRootNode() : e.parentNode ? $46bff87bcc38d89a$var$Te(e.parentNode) : e;
}
function $46bff87bcc38d89a$var$Mo(e) {
    for(; e;){
        if (e instanceof HTMLElement && e.popover === "auto" && $46bff87bcc38d89a$var$xe.get(e) === "showing") return e;
        if (e = e instanceof Element && e.assignedSlot || e.parentElement || $46bff87bcc38d89a$var$Te(e), e instanceof $46bff87bcc38d89a$var$Nt && (e = e.host), e instanceof Document) return;
    }
}
function $46bff87bcc38d89a$var$Mn(e) {
    for(; e;){
        let o = e.popoverTargetElement;
        if (o instanceof HTMLElement) return o;
        if (e = e.parentElement || $46bff87bcc38d89a$var$Te(e), e instanceof $46bff87bcc38d89a$var$Nt && (e = e.host), e instanceof Document) return;
    }
}
function $46bff87bcc38d89a$var$Po(e, o) {
    let t = new Map, n = 0;
    for (let s of o || [])t.set(s, n), n += 1;
    t.set(e, n), n += 1;
    let r = null;
    function i(s) {
        if (!s) return;
        let a = !1, l = null, u = null;
        for(; !a;){
            if (l = $46bff87bcc38d89a$var$Mo(s) || null, l === null || !t.has(l)) return;
            (e.popover === "hint" || l.popover === "auto") && (a = !0), a || (s = l.parentElement);
        }
        u = t.get(l), (r === null || t.get(r) < u) && (r = l);
    }
    return i(e.parentElement || $46bff87bcc38d89a$var$Te(e)), r;
}
function $46bff87bcc38d89a$var$Hn(e) {
    return e.hidden || e instanceof $46bff87bcc38d89a$var$Nt || (e instanceof HTMLButtonElement || e instanceof HTMLInputElement || e instanceof HTMLSelectElement || e instanceof HTMLTextAreaElement || e instanceof HTMLOptGroupElement || e instanceof HTMLOptionElement || e instanceof HTMLFieldSetElement) && e.disabled || e instanceof HTMLInputElement && e.type === "hidden" || e instanceof HTMLAnchorElement && e.href === "" ? !1 : typeof e.tabIndex == "number" && e.tabIndex !== -1;
}
function $46bff87bcc38d89a$var$Rn(e) {
    if (e.shadowRoot && e.shadowRoot.delegatesFocus !== !0) return null;
    let o = e;
    o.shadowRoot && (o = o.shadowRoot);
    let t = o.querySelector("[autofocus]");
    if (t) return t;
    {
        let i = o.querySelectorAll("slot");
        for (let s of i){
            let a = s.assignedElements({
                flatten: !0
            });
            for (let l of a){
                if (l.hasAttribute("autofocus")) return l;
                if (t = l.querySelector("[autofocus]"), t) return t;
            }
        }
    }
    let n = e.ownerDocument.createTreeWalker(o, NodeFilter.SHOW_ELEMENT), r = n.currentNode;
    for(; r;){
        if ($46bff87bcc38d89a$var$Hn(r)) return r;
        r = n.nextNode();
    }
}
function $46bff87bcc38d89a$var$Bn(e) {
    var o;
    (o = $46bff87bcc38d89a$var$Rn(e)) == null || o.focus();
}
var $46bff87bcc38d89a$var$lt = new WeakMap;
function $46bff87bcc38d89a$var$Rt(e) {
    if (!$46bff87bcc38d89a$var$pe(e, !1)) return;
    let o = e.ownerDocument;
    if (!e.dispatchEvent(new $46bff87bcc38d89a$var$at("beforetoggle", {
        cancelable: !0,
        oldState: "closed",
        newState: "open"
    })) || !$46bff87bcc38d89a$var$pe(e, !1)) return;
    let t = !1, n = e.popover, r = null, i = $46bff87bcc38d89a$var$Po(e, $46bff87bcc38d89a$var$X.get(o) || new Set), s = $46bff87bcc38d89a$var$Po(e, $46bff87bcc38d89a$var$q.get(o) || new Set);
    if (n === "auto" && ($46bff87bcc38d89a$var$Bt($46bff87bcc38d89a$var$q.get(o) || new Set, t, !0), $46bff87bcc38d89a$var$me(i || o, t, !0), r = "auto"), n === "hint" && (s ? ($46bff87bcc38d89a$var$me(s, t, !0), r = "hint") : ($46bff87bcc38d89a$var$Bt($46bff87bcc38d89a$var$q.get(o) || new Set, t, !0), i ? ($46bff87bcc38d89a$var$me(i, t, !0), r = "auto") : r = "hint")), n === "auto" || n === "hint") {
        if (n !== e.popover || !$46bff87bcc38d89a$var$pe(e, !1)) return;
        $46bff87bcc38d89a$var$Ve(o) || (t = !0), r === "auto" ? ($46bff87bcc38d89a$var$X.has(o) || $46bff87bcc38d89a$var$X.set(o, new Set), $46bff87bcc38d89a$var$X.get(o).add(e)) : r === "hint" && ($46bff87bcc38d89a$var$q.has(o) || $46bff87bcc38d89a$var$q.set(o, new Set), $46bff87bcc38d89a$var$q.get(o).add(e));
    }
    $46bff87bcc38d89a$var$lt.delete(e);
    let a = o.activeElement;
    e.classList.add(":popover-open"), $46bff87bcc38d89a$var$xe.set(e, "showing"), $46bff87bcc38d89a$var$rt.has(o) || $46bff87bcc38d89a$var$rt.set(o, new Set), $46bff87bcc38d89a$var$rt.get(o).add(e), $46bff87bcc38d89a$var$Ho($46bff87bcc38d89a$var$st.get(e), !0), $46bff87bcc38d89a$var$Bn(e), t && a && e.popover === "auto" && $46bff87bcc38d89a$var$lt.set(e, a), $46bff87bcc38d89a$var$Do(e, "closed", "open");
}
function $46bff87bcc38d89a$var$Se(e, o = !1, t = !1) {
    var n, r;
    if (!$46bff87bcc38d89a$var$pe(e, !0)) return;
    let i = e.ownerDocument;
    if ([
        "auto",
        "hint"
    ].includes(e.popover) && ($46bff87bcc38d89a$var$me(e, o, t), !$46bff87bcc38d89a$var$pe(e, !0))) return;
    let s = $46bff87bcc38d89a$var$X.get(i) || new Set, a = s.has(e) && $46bff87bcc38d89a$var$qe(s) === e;
    if ($46bff87bcc38d89a$var$Ho($46bff87bcc38d89a$var$st.get(e), !1), $46bff87bcc38d89a$var$st.delete(e), t && (e.dispatchEvent(new $46bff87bcc38d89a$var$at("beforetoggle", {
        oldState: "open",
        newState: "closed"
    })), a && $46bff87bcc38d89a$var$qe(s) !== e && $46bff87bcc38d89a$var$me(e, o, t), !$46bff87bcc38d89a$var$pe(e, !0))) return;
    (n = $46bff87bcc38d89a$var$rt.get(i)) == null || n.delete(e), s.delete(e), (r = $46bff87bcc38d89a$var$q.get(i)) == null || r.delete(e), e.classList.remove(":popover-open"), $46bff87bcc38d89a$var$xe.set(e, "hidden"), t && $46bff87bcc38d89a$var$Do(e, "open", "closed");
    let l = $46bff87bcc38d89a$var$lt.get(e);
    l && ($46bff87bcc38d89a$var$lt.delete(e), o && l.focus());
}
function $46bff87bcc38d89a$var$Nn(e, o = !1, t = !1) {
    let n = $46bff87bcc38d89a$var$Ve(e);
    for(; n;)$46bff87bcc38d89a$var$Se(n, o, t), n = $46bff87bcc38d89a$var$Ve(e);
}
function $46bff87bcc38d89a$var$Bt(e, o = !1, t = !1) {
    let n = $46bff87bcc38d89a$var$Io(e);
    for(; n;)$46bff87bcc38d89a$var$Se(n, o, t), n = $46bff87bcc38d89a$var$Io(e);
}
function $46bff87bcc38d89a$var$ko(e, o, t, n) {
    let r = !1, i = !1;
    for(; r || !i;){
        i = !0;
        let s = null, a = !1;
        for (let l of o)if (l === e) a = !0;
        else if (a) {
            s = l;
            break;
        }
        if (!s) return;
        for(; $46bff87bcc38d89a$var$it(s) === "showing" && o.size;)$46bff87bcc38d89a$var$Se($46bff87bcc38d89a$var$qe(o), t, n);
        o.has(e) && $46bff87bcc38d89a$var$qe(o) !== e && (r = !0), r && (n = !1);
    }
}
function $46bff87bcc38d89a$var$me(e, o, t) {
    var n, r;
    let i = e.ownerDocument || e;
    if (e instanceof Document) return $46bff87bcc38d89a$var$Nn(i, o, t);
    if ((n = $46bff87bcc38d89a$var$q.get(i)) != null && n.has(e)) {
        $46bff87bcc38d89a$var$ko(e, $46bff87bcc38d89a$var$q.get(i), o, t);
        return;
    }
    $46bff87bcc38d89a$var$Bt($46bff87bcc38d89a$var$q.get(i) || new Set, o, t), (r = $46bff87bcc38d89a$var$X.get(i)) != null && r.has(e) && $46bff87bcc38d89a$var$ko(e, $46bff87bcc38d89a$var$X.get(i), o, t);
}
var $46bff87bcc38d89a$var$Dt = new WeakMap;
function $46bff87bcc38d89a$var$Oo(e) {
    if (!e.isTrusted) return;
    let o = e.composedPath()[0];
    if (!o) return;
    let t = o.ownerDocument;
    if (!$46bff87bcc38d89a$var$Ve(t)) return;
    let r = $46bff87bcc38d89a$var$Dn(o);
    if (r && e.type === "pointerdown") $46bff87bcc38d89a$var$Dt.set(t, r);
    else if (e.type === "pointerup") {
        let i = $46bff87bcc38d89a$var$Dt.get(t) === r;
        $46bff87bcc38d89a$var$Dt.delete(t), i && $46bff87bcc38d89a$var$me(r || t, !1, !0);
    }
}
var $46bff87bcc38d89a$var$Mt = new WeakMap;
function $46bff87bcc38d89a$var$Ho(e, o = !1) {
    if (!e) return;
    $46bff87bcc38d89a$var$Mt.has(e) || $46bff87bcc38d89a$var$Mt.set(e, e.getAttribute("aria-expanded"));
    let t = e.popoverTargetElement;
    if (t instanceof HTMLElement && t.popover === "auto") e.setAttribute("aria-expanded", String(o));
    else {
        let n = $46bff87bcc38d89a$var$Mt.get(e);
        n ? e.setAttribute("aria-expanded", n) : e.removeAttribute("aria-expanded");
    }
}
var $46bff87bcc38d89a$var$Co = globalThis.ShadowRoot || function() {};
function $46bff87bcc38d89a$var$Ro() {
    return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
}
function $46bff87bcc38d89a$var$de(e, o, t) {
    let n = e[o];
    Object.defineProperty(e, o, {
        value (r) {
            return n.call(this, t(r));
        }
    });
}
var $46bff87bcc38d89a$var$Fn = /(^|[^\\]):popover-open\b/g;
function $46bff87bcc38d89a$var$qn() {
    return typeof globalThis.CSSLayerBlockRule == "function";
}
function $46bff87bcc38d89a$var$Vn() {
    let e = $46bff87bcc38d89a$var$qn();
    return `
${e ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${e ? "}" : ""}
`;
}
var $46bff87bcc38d89a$var$Ae = null;
function $46bff87bcc38d89a$var$Ht(e) {
    let o = $46bff87bcc38d89a$var$Vn();
    if ($46bff87bcc38d89a$var$Ae === null) try {
        $46bff87bcc38d89a$var$Ae = new CSSStyleSheet, $46bff87bcc38d89a$var$Ae.replaceSync(o);
    } catch  {
        $46bff87bcc38d89a$var$Ae = !1;
    }
    if ($46bff87bcc38d89a$var$Ae === !1) {
        let t = document.createElement("style");
        t.textContent = o, e instanceof Document ? e.head.prepend(t) : e.prepend(t);
    } else e.adoptedStyleSheets = [
        $46bff87bcc38d89a$var$Ae,
        ...e.adoptedStyleSheets
    ];
}
function $46bff87bcc38d89a$var$Bo() {
    if (typeof window > "u") return;
    window.ToggleEvent = window.ToggleEvent || $46bff87bcc38d89a$var$at;
    function e(l) {
        return l?.includes(":popover-open") && (l = l.replace($46bff87bcc38d89a$var$Fn, "$1.\\:popover-open")), l;
    }
    $46bff87bcc38d89a$var$de(Document.prototype, "querySelector", e), $46bff87bcc38d89a$var$de(Document.prototype, "querySelectorAll", e), $46bff87bcc38d89a$var$de(Element.prototype, "querySelector", e), $46bff87bcc38d89a$var$de(Element.prototype, "querySelectorAll", e), $46bff87bcc38d89a$var$de(Element.prototype, "matches", e), $46bff87bcc38d89a$var$de(Element.prototype, "closest", e), $46bff87bcc38d89a$var$de(DocumentFragment.prototype, "querySelectorAll", e), Object.defineProperties(HTMLElement.prototype, {
        popover: {
            enumerable: !0,
            configurable: !0,
            get () {
                if (!this.hasAttribute("popover")) return null;
                let l = (this.getAttribute("popover") || "").toLowerCase();
                return l === "" || l == "auto" ? "auto" : l == "hint" ? "hint" : "manual";
            },
            set (l) {
                l === null ? this.removeAttribute("popover") : this.setAttribute("popover", l);
            }
        },
        showPopover: {
            enumerable: !0,
            configurable: !0,
            value (l = {}) {
                $46bff87bcc38d89a$var$Rt(this);
            }
        },
        hidePopover: {
            enumerable: !0,
            configurable: !0,
            value () {
                $46bff87bcc38d89a$var$Se(this, !0, !0);
            }
        },
        togglePopover: {
            enumerable: !0,
            configurable: !0,
            value (l = {}) {
                return typeof l == "boolean" && (l = {
                    force: l
                }), $46bff87bcc38d89a$var$xe.get(this) === "showing" && l.force === void 0 || l.force === !1 ? $46bff87bcc38d89a$var$Se(this, !0, !0) : (l.force === void 0 || l.force === !0) && $46bff87bcc38d89a$var$Rt(this), $46bff87bcc38d89a$var$xe.get(this) === "showing";
            }
        }
    });
    let o = Element.prototype.attachShadow;
    o && Object.defineProperties(Element.prototype, {
        attachShadow: {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value (l) {
                let u = o.call(this, l);
                return $46bff87bcc38d89a$var$Ht(u), u;
            }
        }
    });
    let t = HTMLElement.prototype.attachInternals;
    t && Object.defineProperties(HTMLElement.prototype, {
        attachInternals: {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value () {
                let l = t.call(this);
                return l.shadowRoot && $46bff87bcc38d89a$var$Ht(l.shadowRoot), l;
            }
        }
    });
    let n = new WeakMap;
    function r(l) {
        Object.defineProperties(l.prototype, {
            popoverTargetElement: {
                enumerable: !0,
                configurable: !0,
                set (u) {
                    if (u === null) this.removeAttribute("popovertarget"), n.delete(this);
                    else if (u instanceof Element) this.setAttribute("popovertarget", ""), n.set(this, u);
                    else throw new TypeError("popoverTargetElement must be an element or null");
                },
                get () {
                    if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit") return null;
                    let u = n.get(this);
                    if (u && u.isConnected) return u;
                    if (u && !u.isConnected) return n.delete(this), null;
                    let g = $46bff87bcc38d89a$var$Te(this), m = this.getAttribute("popovertarget");
                    return (g instanceof Document || g instanceof $46bff87bcc38d89a$var$Co) && m && g.getElementById(m) || null;
                }
            },
            popoverTargetAction: {
                enumerable: !0,
                configurable: !0,
                get () {
                    let u = (this.getAttribute("popovertargetaction") || "").toLowerCase();
                    return u === "show" || u === "hide" ? u : "toggle";
                },
                set (u) {
                    this.setAttribute("popovertargetaction", u);
                }
            }
        });
    }
    r(HTMLButtonElement), r(HTMLInputElement);
    let i = (l)=>{
        if (l.defaultPrevented) return;
        let u = l.composedPath(), g = u[0];
        if (!(g instanceof Element) || g?.shadowRoot) return;
        let m = $46bff87bcc38d89a$var$Te(g);
        if (!(m instanceof $46bff87bcc38d89a$var$Co || m instanceof Document)) return;
        let c = u.find((b)=>{
            var f;
            return (f = b.matches) == null ? void 0 : f.call(b, "[popovertargetaction],[popovertarget]");
        });
        if (c) {
            $46bff87bcc38d89a$var$Cn(c), l.preventDefault();
            return;
        }
    }, s = (l)=>{
        let u = l.key, g = l.target;
        !l.defaultPrevented && g && (u === "Escape" || u === "Esc") && $46bff87bcc38d89a$var$me(g.ownerDocument, !0, !0);
    };
    ((l)=>{
        l.addEventListener("click", i), l.addEventListener("keydown", s), l.addEventListener("pointerdown", $46bff87bcc38d89a$var$Oo), l.addEventListener("pointerup", $46bff87bcc38d89a$var$Oo);
    })(document), $46bff87bcc38d89a$var$Ht(document);
}
function $46bff87bcc38d89a$var$No() {
    return typeof HTMLButtonElement < "u" && "command" in HTMLButtonElement.prototype && "source" in ((globalThis.CommandEvent || {}).prototype || {});
}
function $46bff87bcc38d89a$var$Fo() {
    document.addEventListener("invoke", (f)=>{
        f.type == "invoke" && f.isTrusted && (f.stopImmediatePropagation(), f.preventDefault());
    }, !0), document.addEventListener("command", (f)=>{
        f.type == "command" && f.isTrusted && (f.stopImmediatePropagation(), f.preventDefault());
    }, !0);
    function e(f, h, p = !0) {
        Object.defineProperty(f, h, {
            ...Object.getOwnPropertyDescriptor(f, h),
            enumerable: p
        });
    }
    function o(f) {
        return f && typeof f.getRootNode == "function" ? f.getRootNode() : f && f.parentNode ? o(f.parentNode) : f;
    }
    let t = new WeakMap, n = new WeakMap;
    class r extends Event {
        constructor(h, p = {}){
            super(h, p);
            let { source: v, command: y } = p;
            if (v != null && !(v instanceof Element)) throw new TypeError("source must be an element");
            t.set(this, v || null), n.set(this, y !== void 0 ? String(y) : "");
        }
        get [Symbol.toStringTag]() {
            return "CommandEvent";
        }
        get source() {
            if (!t.has(this)) throw new TypeError("illegal invocation");
            let h = t.get(this);
            if (!(h instanceof Element)) return null;
            let p = o(h);
            return p !== o(this.target || document) ? p.host : h;
        }
        get command() {
            if (!n.has(this)) throw new TypeError("illegal invocation");
            return n.get(this);
        }
        get action() {
            throw new Error("CommandEvent#action was renamed to CommandEvent#command");
        }
        get invoker() {
            throw new Error("CommandEvent#invoker was renamed to CommandEvent#source");
        }
    }
    e(r.prototype, "source"), e(r.prototype, "command");
    class i extends Event {
        constructor(h, p = {}){
            throw super(h, p), new Error("InvokeEvent has been deprecated, it has been renamed to `CommandEvent`");
        }
    }
    let s = new WeakMap;
    function a(f) {
        Object.defineProperties(f.prototype, {
            commandForElement: {
                enumerable: !0,
                configurable: !0,
                set (h) {
                    if (this.hasAttribute("invokeaction")) throw new TypeError("Element has deprecated `invokeaction` attribute, replace with `command`");
                    if (this.hasAttribute("invoketarget")) throw new TypeError("Element has deprecated `invoketarget` attribute, replace with `commandfor`");
                    if (h === null) this.removeAttribute("commandfor"), s.delete(this);
                    else if (h instanceof Element) {
                        this.setAttribute("commandfor", "");
                        let p = o(h);
                        o(this) === p || p === this.ownerDocument ? s.set(this, h) : s.delete(this);
                    } else throw new TypeError("commandForElement must be an element or null");
                },
                get () {
                    if (this.localName !== "button") return null;
                    if (this.hasAttribute("invokeaction") || this.hasAttribute("invoketarget")) return console.warn("Element has deprecated `invoketarget` or `invokeaction` attribute, use `commandfor` and `command` instead"), null;
                    if (this.disabled) return null;
                    if (this.form && this.getAttribute("type") !== "button") return console.warn("Element with `commandFor` is a form participant. It should explicitly set `type=button` in order for `commandFor` to work"), null;
                    let h = s.get(this);
                    if (h) return h.isConnected ? h : (s.delete(this), null);
                    let p = o(this), v = this.getAttribute("commandfor");
                    return (p instanceof Document || p instanceof ShadowRoot) && v && p.getElementById(v) || null;
                }
            },
            command: {
                enumerable: !0,
                configurable: !0,
                get () {
                    let h = this.getAttribute("command") || "";
                    if (h.startsWith("--")) return h;
                    let p = h.toLowerCase();
                    switch(p){
                        case "show-modal":
                        case "close":
                        case "toggle-popover":
                        case "hide-popover":
                        case "show-popover":
                            return p;
                    }
                    return "";
                },
                set (h) {
                    this.setAttribute("command", h);
                }
            },
            invokeAction: {
                enumerable: !1,
                configurable: !0,
                get () {
                    throw new Error("invokeAction is deprecated. It has been renamed to command");
                },
                set (h) {
                    throw new Error("invokeAction is deprecated. It has been renamed to command");
                }
            },
            invokeTargetElement: {
                enumerable: !1,
                configurable: !0,
                get () {
                    throw new Error("invokeTargetElement is deprecated. It has been renamed to command");
                },
                set (h) {
                    throw new Error("invokeTargetElement is deprecated. It has been renamed to command");
                }
            }
        });
    }
    let l = new WeakMap;
    Object.defineProperties(HTMLElement.prototype, {
        oncommand: {
            enumerable: !0,
            configurable: !0,
            get () {
                return g.takeRecords(), l.get(this) || null;
            },
            set (f) {
                let h = l.get(this) || null;
                h && this.removeEventListener("command", h), l.set(this, typeof f == "object" || typeof f == "function" ? f : null), typeof f == "function" && this.addEventListener("command", f);
            }
        }
    });
    function u(f) {
        for (let h of f)h.oncommand = new Function("event", h.getAttribute("oncommand"));
    }
    let g = new MutationObserver((f)=>{
        for (let h of f){
            let { target: p } = h;
            h.type === "childList" ? u(p.querySelectorAll("[oncommand]")) : u([
                p
            ]);
        }
    });
    g.observe(document, {
        subtree: !0,
        childList: !0,
        attributeFilter: [
            "oncommand"
        ]
    }), u(document.querySelectorAll("[oncommand]"));
    function m(f) {
        if (f.defaultPrevented || f.type !== "click") return;
        let h = f.target.closest("button[invoketarget], button[invokeaction], input[invoketarget], input[invokeaction]");
        if (h && (console.warn("Elements with `invoketarget` or `invokeaction` are deprecated and should be renamed to use `commandfor` and `command` respectively"), h.matches("input"))) throw new Error("Input elements no longer support `commandfor`");
        let p = f.target.closest("button[commandfor], button[command]");
        if (!p) return;
        if (p.form && p.getAttribute("type") !== "button") throw f.preventDefault(), new Error("Element with `commandFor` is a form participant. It should explicitly set `type=button` in order for `commandFor` to work. In order for it to act as a Submit button, it must not have command or commandfor attributes");
        if (p.hasAttribute("command") !== p.hasAttribute("commandfor")) {
            let w = p.hasAttribute("command") ? "command" : "commandfor", E = p.hasAttribute("command") ? "commandfor" : "command";
            throw new Error(`Element with ${w} attribute must also have a ${E} attribute to function.`);
        }
        if (p.command !== "show-popover" && p.command !== "hide-popover" && p.command !== "toggle-popover" && p.command !== "show-modal" && p.command !== "close" && !p.command.startsWith("--")) {
            console.warn(`"${p.command}" is not a valid command value. Custom commands must begin with --`);
            return;
        }
        let v = p.commandForElement;
        if (!v) return;
        let y = new r("command", {
            command: p.command,
            source: p,
            cancelable: !0
        });
        if (v.dispatchEvent(y), y.defaultPrevented) return;
        let x = y.command.toLowerCase();
        if (v.popover) {
            let w = !v.matches(":popover-open");
            w && (x === "toggle-popover" || x === "show-popover") ? v.showPopover({
                source: p
            }) : !w && x === "hide-popover" && v.hidePopover();
        } else if (v.localName === "dialog") {
            let w = !v.hasAttribute("open");
            w && x === "show-modal" ? v.showModal() : !w && x === "close" && v.close();
        }
    }
    function c(f) {
        f.addEventListener("click", m, !0);
    }
    function b(f, h) {
        let p = f.prototype.attachShadow;
        f.prototype.attachShadow = function(y) {
            let x = p.call(this, y);
            return h(x), x;
        };
        let v = f.prototype.attachInternals;
        f.prototype.attachInternals = function() {
            let y = v.call(this);
            return y.shadowRoot && h(y.shadowRoot), y;
        };
    }
    a(HTMLButtonElement), b(HTMLElement, (f)=>{
        c(f), g.observe(f, {
            attributeFilter: [
                "oncommand"
            ]
        }), u(f.querySelectorAll("[oncommand]"));
    }), c(document), Object.assign(globalThis, {
        CommandEvent: r,
        InvokeEvent: i
    });
}
function $46bff87bcc38d89a$var$qo() {
    if (typeof HTMLDialogElement != "function") return !1;
    let e = !1, o = document.createElement("dialog");
    return o.addEventListener("beforetoggle", (t)=>{
        e = !0, t.preventDefault();
    }), o.show(), e;
}
function $46bff87bcc38d89a$var$Vo() {
    let e = new WeakMap;
    function o(s) {
        let a = s.open ? "closed" : "open", l = s.open ? "open" : "closed";
        if (e.has(s)) {
            let u = e.get(s);
            l = u.oldState, clearTimeout(u.id);
        }
        e.set(s, {
            oldState: l,
            id: setTimeout(()=>{
                s.dispatchEvent(new ToggleEvent("toggle", {
                    newState: a,
                    oldState: l
                }));
            })
        });
    }
    let t = HTMLDialogElement.prototype.show, n = HTMLDialogElement.prototype.showModal, r = HTMLDialogElement.prototype.close;
    function i(s) {
        let a = new ToggleEvent("beforetoggle", {
            newState: "closed",
            oldState: "open",
            cancelable: !1
        });
        s.dispatchEvent(a), s.open && o(s);
    }
    document.addEventListener("submit", (s)=>{
        let a = s.target;
        if (a.method === "dialog") {
            let l = a.closest("dialog");
            l instanceof HTMLDialogElement && i(l);
        }
    }, !0), Object.defineProperties(HTMLDialogElement.prototype, {
        show: {
            value () {
                if (this.open || this.matches(":popover-open, :modal") || !this.ownerDocument) return t.apply(this, arguments);
                let s = new ToggleEvent("beforetoggle", {
                    newState: "open",
                    oldState: "closed",
                    cancelable: !0
                });
                this.dispatchEvent(s) && (o(this), t.apply(this, arguments));
            }
        },
        showModal: {
            value () {
                if (this.open || this.matches(":popover-open, :modal") || !this.isConnected || !this.ownerDocument) return n.apply(this, arguments);
                let s = new ToggleEvent("beforetoggle", {
                    newState: "open",
                    oldState: "closed",
                    cancelable: !0
                });
                if (this.dispatchEvent(s)) return o(this), n.apply(this, arguments);
            }
        },
        close: {
            value () {
                return !this.open && !this.matches(":popover-open, :modal") ? r.apply(this, arguments) : (i(this), r.apply(this, arguments));
            }
        }
    });
}
function $46bff87bcc38d89a$var$ut(e) {
    function o() {
        document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", o));
    }
    typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", o), o());
}
typeof globalThis.window < "u" && ($46bff87bcc38d89a$var$Ro() || ($46bff87bcc38d89a$var$Bo(), $46bff87bcc38d89a$var$ut(async ()=>{
    if (await $46bff87bcc38d89a$var$Wn("popover-polyfill")) return;
    let e = document.createElement("style");
    e.textContent = "@layer popover-polyfill;", e.setAttribute("suppressHydrationWarning", ""), e.addEventListener("securitypolicyviolation", ()=>{
        console.log("CSP rules on this website prevented @tailwindplus/elements from defining `popover-polyfill` as the first CSS layer. This is necessary to ensure the popover polyfill behaves correctly with CSS layers. To fix this, please manually add the following CSS to the top of your first stylesheet:\n\n```\n@layer popover-polyfill;\n```");
    }), document.documentElement.prepend(e);
})), $46bff87bcc38d89a$var$No() || $46bff87bcc38d89a$var$Fo(), $46bff87bcc38d89a$var$qo() || $46bff87bcc38d89a$var$Vo());
async function $46bff87bcc38d89a$var$Wn(e) {
    await $46bff87bcc38d89a$var$$n();
    for (let o of document.styleSheets)try {
        for (let t of o.rules)if (t.constructor.name === "CSSLayerStatementRule" && "nameList" in t && t.nameList.includes(e)) return !0;
    } catch  {}
    return !1;
}
async function $46bff87bcc38d89a$var$$n() {
    await Promise.all(Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map((e)=>e.sheet ? Promise.resolve() : new Promise((o)=>{
            e.addEventListener("load", ()=>o(), {
                once: !0
            }), e.addEventListener("error", ()=>o(), {
                once: !0
            });
        })));
}
function $46bff87bcc38d89a$var$Le(e) {
    "focus" in e && e.focus({
        focusVisible: $46bff87bcc38d89a$var$ct
    });
}
var $46bff87bcc38d89a$var$ct = !1;
if (typeof globalThis.window < "u") {
    let e;
    ((n)=>(n[n.Keyboard = 0] = "Keyboard", n[n.Mouse = 1] = "Mouse"))(e || (e = {})), document.addEventListener("keydown", (o)=>{
        o.metaKey || o.altKey || o.ctrlKey || ($46bff87bcc38d89a$var$ct = !0, document.documentElement.dataset.focusVisible = "");
    }, !0), document.addEventListener("click", (o)=>{
        o.detail === 1 ? ($46bff87bcc38d89a$var$ct = !1, delete document.documentElement.dataset.focusVisible) : o.detail === 0 && ($46bff87bcc38d89a$var$ct = !0, document.documentElement.dataset.focusVisible = "");
    }, !0);
}
typeof globalThis.HTMLElement > "u" && (globalThis.HTMLElement = class {
});
var $46bff87bcc38d89a$var$Ie, $46bff87bcc38d89a$var$We, $46bff87bcc38d89a$var$se, $46bff87bcc38d89a$var$A = class extends HTMLElement {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Ie, new AbortController);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$We, !1);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$se, !1);
    }
    connectedCallback() {
        if ("observedAttributes" in this.constructor && typeof this.constructor.observedAttributes == "object" && Array.isArray(this.constructor.observedAttributes)) for (let n of this.constructor.observedAttributes)typeof n == "string" && (n in this || Object.defineProperty(this, n, {
            get () {
                return this.getAttribute(n);
            },
            set (r) {
                if (r == null || r === !1) {
                    this.removeAttribute(n);
                    return;
                }
                this.setAttribute(n, r.toString());
            }
        }));
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$We, !0);
        let t = $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ie).signal;
        queueMicrotask(()=>{
            if (!t.aborted) try {
                this.mount?.(t);
            } catch (n) {
                console.error(n);
            }
        });
    }
    disconnectedCallback() {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ie).abort(), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Ie, new AbortController);
    }
    setAttributeNoCallbacks(t, n) {
        try {
            $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$se, !0), this.setAttribute(t, n);
        } finally{
            $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$se, !1);
        }
    }
    removeAttributeNoCallbacks(t) {
        try {
            $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$se, !0), this.removeAttribute(t);
        } finally{
            $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$se, !1);
        }
    }
    attributeChangedCallback(t, n, r) {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$We) && ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$se) || n !== r && this.onAttributeChange?.(t, n, r));
    }
};
$46bff87bcc38d89a$var$Ie = new WeakMap, $46bff87bcc38d89a$var$We = new WeakMap, $46bff87bcc38d89a$var$se = new WeakMap;
function $46bff87bcc38d89a$var$T(e, o) {
    typeof globalThis.customElements > "u" || customElements.get(e) === o || customElements.define(e, o);
}
function $46bff87bcc38d89a$var$J() {
    let e = [], o = {
        addEventListener (t, n, r, i) {
            return t.addEventListener(n, r, i), o.add(()=>t.removeEventListener(n, r, i));
        },
        requestAnimationFrame (...t) {
            let n = requestAnimationFrame(...t);
            return o.add(()=>cancelAnimationFrame(n));
        },
        nextFrame (...t) {
            return o.requestAnimationFrame(()=>o.requestAnimationFrame(...t));
        },
        setTimeout (...t) {
            let n = setTimeout(...t);
            return o.add(()=>clearTimeout(n));
        },
        microTask (...t) {
            let n = {
                current: !0
            };
            return queueMicrotask(()=>{
                n.current && t[0]();
            }), o.add(()=>{
                n.current = !1;
            });
        },
        style (t, n, r) {
            let i = t.style.getPropertyValue(n);
            return n.startsWith("--") ? t.style.setProperty(n, r) : Object.assign(t.style, {
                [n]: r
            }), this.add(()=>{
                n.startsWith("--") ? t.style.setProperty(n, i) : Object.assign(t.style, {
                    [n]: i
                });
            });
        },
        add (t) {
            return e.includes(t) || e.push(t), ()=>{
                let n = e.indexOf(t);
                if (n >= 0) for (let r of e.splice(n, 1))r();
            };
        },
        dispose () {
            for (let t of e.splice(0))t();
        }
    };
    return o;
}
function $46bff87bcc38d89a$var$Pe(e, o = ()=>[]) {
    let t = !1, n = null, r = $46bff87bcc38d89a$var$J();
    return {
        start (i, s) {
            let a = [
                e,
                ...o()
            ];
            t ? t = !1 : t = n !== null && n !== i, n = i;
            for (let l of a)$46bff87bcc38d89a$var$_n(l, ()=>{
                t || (i === "in" ? (l.dataset.transition = "", l.dataset.enter = "", l.dataset.closed = "", delete l.dataset.leave) : i === "out" && (l.dataset.transition = "", l.dataset.leave = "", delete l.dataset.enter));
            }, n !== null);
            r.nextFrame(()=>{
                for (let l of a)t ? i === "in" ? (delete l.dataset.enter, delete l.dataset.closed, l.dataset.leave = "") : i === "out" && (delete l.dataset.leave, l.dataset.enter = "", l.dataset.closed = "") : i === "in" ? delete l.dataset.closed : i === "out" && (l.dataset.closed = "");
                r.requestAnimationFrame(()=>{
                    r.add($46bff87bcc38d89a$var$Ft(e, ()=>{
                        if (!(t && a.some((l)=>$46bff87bcc38d89a$var$qt(l)))) {
                            for (let l of a)delete l.dataset.transition, delete l.dataset.enter, delete l.dataset.closed, delete l.dataset.leave;
                            n = null, s?.();
                        }
                    }));
                });
            });
        },
        abort () {
            r.dispose(), t = !1, n = null;
        }
    };
}
function $46bff87bcc38d89a$var$_n(e, o, t = !1) {
    if (t) {
        o();
        return;
    }
    let n = e.style.transition;
    e.style.transition = "none", o(), e.offsetHeight, e.style.transition = n;
}
function $46bff87bcc38d89a$var$Ft(e, o) {
    let t = $46bff87bcc38d89a$var$J();
    if (!e) return t.dispose;
    let n = !1;
    t.add(()=>{
        n = !0;
    });
    let r = e.getAnimations?.({
        subtree: !0
    }).filter((i)=>i instanceof CSSTransition) ?? [];
    return r.length === 0 ? (o(), t.dispose) : (Promise.allSettled(r.map((i)=>i.finished)).then(()=>{
        n || o();
    }), t.dispose);
}
function $46bff87bcc38d89a$var$qt(e) {
    return (e.getAnimations?.() ?? []).some((t)=>t instanceof CSSTransition && t.playState !== "finished");
}
var $46bff87bcc38d89a$var$ke = Math.min, $46bff87bcc38d89a$var$Z = Math.max, $46bff87bcc38d89a$var$_e = Math.round, $46bff87bcc38d89a$var$Ke = Math.floor, $46bff87bcc38d89a$var$K = (e)=>({
        x: e,
        y: e
    }), $46bff87bcc38d89a$var$Kn = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
}, $46bff87bcc38d89a$var$Un = {
    start: "end",
    end: "start"
};
function $46bff87bcc38d89a$var$Vt(e, o, t) {
    return $46bff87bcc38d89a$var$Z(e, $46bff87bcc38d89a$var$ke(o, t));
}
function $46bff87bcc38d89a$var$dt(e, o) {
    return typeof e == "function" ? e(o) : e;
}
function $46bff87bcc38d89a$var$he(e) {
    return e.split("-")[0];
}
function $46bff87bcc38d89a$var$pt(e) {
    return e.split("-")[1];
}
function $46bff87bcc38d89a$var$Wt(e) {
    return e === "x" ? "y" : "x";
}
function $46bff87bcc38d89a$var$$t(e) {
    return e === "y" ? "height" : "width";
}
var $46bff87bcc38d89a$var$jn = new Set([
    "top",
    "bottom"
]);
function $46bff87bcc38d89a$var$le(e) {
    return $46bff87bcc38d89a$var$jn.has($46bff87bcc38d89a$var$he(e)) ? "y" : "x";
}
function $46bff87bcc38d89a$var$_t(e) {
    return $46bff87bcc38d89a$var$Wt($46bff87bcc38d89a$var$le(e));
}
function $46bff87bcc38d89a$var$_o(e, o, t) {
    t === void 0 && (t = !1);
    let n = $46bff87bcc38d89a$var$pt(e), r = $46bff87bcc38d89a$var$_t(e), i = $46bff87bcc38d89a$var$$t(r), s = r === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
    return o.reference[i] > o.floating[i] && (s = $46bff87bcc38d89a$var$$e(s)), [
        s,
        $46bff87bcc38d89a$var$$e(s)
    ];
}
function $46bff87bcc38d89a$var$Ko(e) {
    let o = $46bff87bcc38d89a$var$$e(e);
    return [
        $46bff87bcc38d89a$var$ft(e),
        o,
        $46bff87bcc38d89a$var$ft(o)
    ];
}
function $46bff87bcc38d89a$var$ft(e) {
    return e.replace(/start|end/g, (o)=>$46bff87bcc38d89a$var$Un[o]);
}
var $46bff87bcc38d89a$var$Wo = [
    "left",
    "right"
], $46bff87bcc38d89a$var$$o = [
    "right",
    "left"
], $46bff87bcc38d89a$var$zn = [
    "top",
    "bottom"
], $46bff87bcc38d89a$var$Gn = [
    "bottom",
    "top"
];
function $46bff87bcc38d89a$var$Yn(e, o, t) {
    switch(e){
        case "top":
        case "bottom":
            return t ? o ? $46bff87bcc38d89a$var$$o : $46bff87bcc38d89a$var$Wo : o ? $46bff87bcc38d89a$var$Wo : $46bff87bcc38d89a$var$$o;
        case "left":
        case "right":
            return o ? $46bff87bcc38d89a$var$zn : $46bff87bcc38d89a$var$Gn;
        default:
            return [];
    }
}
function $46bff87bcc38d89a$var$Uo(e, o, t, n) {
    let r = $46bff87bcc38d89a$var$pt(e), i = $46bff87bcc38d89a$var$Yn($46bff87bcc38d89a$var$he(e), t === "start", n);
    return r && (i = i.map((s)=>s + "-" + r), o && (i = i.concat(i.map($46bff87bcc38d89a$var$ft)))), i;
}
function $46bff87bcc38d89a$var$$e(e) {
    return e.replace(/left|right|bottom|top/g, (o)=>$46bff87bcc38d89a$var$Kn[o]);
}
function $46bff87bcc38d89a$var$Qn(e) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...e
    };
}
function $46bff87bcc38d89a$var$jo(e) {
    return typeof e != "number" ? $46bff87bcc38d89a$var$Qn(e) : {
        top: e,
        right: e,
        bottom: e,
        left: e
    };
}
function $46bff87bcc38d89a$var$ge(e) {
    let { x: o, y: t, width: n, height: r } = e;
    return {
        width: n,
        height: r,
        top: t,
        left: o,
        right: o + n,
        bottom: t + r,
        x: o,
        y: t
    };
}
function $46bff87bcc38d89a$var$zo(e, o, t) {
    let { reference: n, floating: r } = e, i = $46bff87bcc38d89a$var$le(o), s = $46bff87bcc38d89a$var$_t(o), a = $46bff87bcc38d89a$var$$t(s), l = $46bff87bcc38d89a$var$he(o), u = i === "y", g = n.x + n.width / 2 - r.width / 2, m = n.y + n.height / 2 - r.height / 2, c = n[a] / 2 - r[a] / 2, b;
    switch(l){
        case "top":
            b = {
                x: g,
                y: n.y - r.height
            };
            break;
        case "bottom":
            b = {
                x: g,
                y: n.y + n.height
            };
            break;
        case "right":
            b = {
                x: n.x + n.width,
                y: m
            };
            break;
        case "left":
            b = {
                x: n.x - r.width,
                y: m
            };
            break;
        default:
            b = {
                x: n.x,
                y: n.y
            };
    }
    switch($46bff87bcc38d89a$var$pt(o)){
        case "start":
            b[s] -= c * (t && u ? -1 : 1);
            break;
        case "end":
            b[s] += c * (t && u ? -1 : 1);
            break;
    }
    return b;
}
var $46bff87bcc38d89a$var$Go = async (e, o, t)=>{
    let { placement: n = "bottom", strategy: r = "absolute", middleware: i = [], platform: s } = t, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(o)), u = await s.getElementRects({
        reference: e,
        floating: o,
        strategy: r
    }), { x: g, y: m } = $46bff87bcc38d89a$var$zo(u, n, l), c = n, b = {}, f = 0;
    for(let h = 0; h < a.length; h++){
        let { name: p, fn: v } = a[h], { x: y, y: x, data: w, reset: E } = await v({
            x: g,
            y: m,
            initialPlacement: n,
            placement: c,
            strategy: r,
            middlewareData: b,
            rects: u,
            platform: s,
            elements: {
                reference: e,
                floating: o
            }
        });
        g = y ?? g, m = x ?? m, b = {
            ...b,
            [p]: {
                ...b[p],
                ...w
            }
        }, E && f <= 50 && (f++, typeof E == "object" && (E.placement && (c = E.placement), E.rects && (u = E.rects === !0 ? await s.getElementRects({
            reference: e,
            floating: o,
            strategy: r
        }) : E.rects), { x: g, y: m } = $46bff87bcc38d89a$var$zo(u, c, l)), h = -1);
    }
    return {
        x: g,
        y: m,
        placement: c,
        strategy: r,
        middlewareData: b
    };
};
async function $46bff87bcc38d89a$var$Kt(e, o) {
    var t;
    o === void 0 && (o = {});
    let { x: n, y: r, platform: i, rects: s, elements: a, strategy: l } = e, { boundary: u = "clippingAncestors", rootBoundary: g = "viewport", elementContext: m = "floating", altBoundary: c = !1, padding: b = 0 } = $46bff87bcc38d89a$var$dt(o, e), f = $46bff87bcc38d89a$var$jo(b), p = a[c ? m === "floating" ? "reference" : "floating" : m], v = $46bff87bcc38d89a$var$ge(await i.getClippingRect({
        element: (t = await (i.isElement == null ? void 0 : i.isElement(p))) == null || t ? p : p.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
        boundary: u,
        rootBoundary: g,
        strategy: l
    })), y = m === "floating" ? {
        x: n,
        y: r,
        width: s.floating.width,
        height: s.floating.height
    } : s.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), w = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    }, E = $46bff87bcc38d89a$var$ge(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: a,
        rect: y,
        offsetParent: x,
        strategy: l
    }) : y);
    return {
        top: (v.top - E.top + f.top) / w.y,
        bottom: (E.bottom - v.bottom + f.bottom) / w.y,
        left: (v.left - E.left + f.left) / w.x,
        right: (E.right - v.right + f.right) / w.x
    };
}
var $46bff87bcc38d89a$var$Yo = function(e) {
    return e === void 0 && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var t, n;
            let { placement: r, middlewareData: i, rects: s, initialPlacement: a, platform: l, elements: u } = o, { mainAxis: g = !0, crossAxis: m = !0, fallbackPlacements: c, fallbackStrategy: b = "bestFit", fallbackAxisSideDirection: f = "none", flipAlignment: h = !0, ...p } = $46bff87bcc38d89a$var$dt(e, o);
            if ((t = i.arrow) != null && t.alignmentOffset) return {};
            let v = $46bff87bcc38d89a$var$he(r), y = $46bff87bcc38d89a$var$le(a), x = $46bff87bcc38d89a$var$he(a) === a, w = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), E = c || (x || !h ? [
                $46bff87bcc38d89a$var$$e(a)
            ] : $46bff87bcc38d89a$var$Ko(a)), P = f !== "none";
            !c && P && E.push(...$46bff87bcc38d89a$var$Uo(a, h, f, w));
            let S = [
                a,
                ...E
            ], $ = await $46bff87bcc38d89a$var$Kt(o, p), re = [], D = ((n = i.flip) == null ? void 0 : n.overflows) || [];
            if (g && re.push($[v]), m) {
                let ce = $46bff87bcc38d89a$var$_o(r, s, w);
                re.push($[ce[0]], $[ce[1]]);
            }
            if (D = [
                ...D,
                {
                    placement: r,
                    overflows: re
                }
            ], !re.every((ce)=>ce <= 0)) {
                var nt, Ao;
                let ce = (((nt = i.flip) == null ? void 0 : nt.index) || 0) + 1, Ot = S[ce];
                if (Ot && (!(m === "alignment" ? y !== $46bff87bcc38d89a$var$le(Ot) : !1) || D.every((_)=>$46bff87bcc38d89a$var$le(_.placement) === y ? _.overflows[0] > 0 : !0))) return {
                    data: {
                        index: ce,
                        overflows: D
                    },
                    reset: {
                        placement: Ot
                    }
                };
                let Fe = (Ao = D.filter((fe)=>fe.overflows[0] <= 0).sort((fe, _)=>fe.overflows[1] - _.overflows[1])[0]) == null ? void 0 : Ao.placement;
                if (!Fe) switch(b){
                    case "bestFit":
                        {
                            var xo;
                            let fe = (xo = D.filter((_)=>{
                                if (P) {
                                    let ie = $46bff87bcc38d89a$var$le(_.placement);
                                    return ie === y || ie === "y";
                                }
                                return !0;
                            }).map((_)=>[
                                    _.placement,
                                    _.overflows.filter((ie)=>ie > 0).reduce((ie, In)=>ie + In, 0)
                                ]).sort((_, ie)=>_[1] - ie[1])[0]) == null ? void 0 : xo[0];
                            fe && (Fe = fe);
                            break;
                        }
                    case "initialPlacement":
                        Fe = a;
                        break;
                }
                if (r !== Fe) return {
                    reset: {
                        placement: Fe
                    }
                };
            }
            return {};
        }
    };
};
var $46bff87bcc38d89a$var$Qo = function(e) {
    return e === void 0 && (e = {}), {
        name: "shift",
        options: e,
        async fn (o) {
            let { x: t, y: n, placement: r } = o, { mainAxis: i = !0, crossAxis: s = !1, limiter: a = {
                fn: (p)=>{
                    let { x: v, y: y } = p;
                    return {
                        x: v,
                        y: y
                    };
                }
            }, ...l } = $46bff87bcc38d89a$var$dt(e, o), u = {
                x: t,
                y: n
            }, g = await $46bff87bcc38d89a$var$Kt(o, l), m = $46bff87bcc38d89a$var$le($46bff87bcc38d89a$var$he(r)), c = $46bff87bcc38d89a$var$Wt(m), b = u[c], f = u[m];
            if (i) {
                let p = c === "y" ? "top" : "left", v = c === "y" ? "bottom" : "right", y = b + g[p], x = b - g[v];
                b = $46bff87bcc38d89a$var$Vt(y, b, x);
            }
            if (s) {
                let p = m === "y" ? "top" : "left", v = m === "y" ? "bottom" : "right", y = f + g[p], x = f - g[v];
                f = $46bff87bcc38d89a$var$Vt(y, f, x);
            }
            let h = a.fn({
                ...o,
                [c]: b,
                [m]: f
            });
            return {
                ...h,
                data: {
                    x: h.x - t,
                    y: h.y - n,
                    enabled: {
                        [c]: i,
                        [m]: s
                    }
                }
            };
        }
    };
};
function $46bff87bcc38d89a$var$mt() {
    return typeof window < "u";
}
function $46bff87bcc38d89a$var$be(e) {
    return $46bff87bcc38d89a$var$Jo(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function $46bff87bcc38d89a$var$R(e) {
    var o;
    return (e == null || (o = e.ownerDocument) == null ? void 0 : o.defaultView) || window;
}
function $46bff87bcc38d89a$var$U(e) {
    var o;
    return (o = ($46bff87bcc38d89a$var$Jo(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : o.documentElement;
}
function $46bff87bcc38d89a$var$Jo(e) {
    return $46bff87bcc38d89a$var$mt() ? e instanceof Node || e instanceof $46bff87bcc38d89a$var$R(e).Node : !1;
}
function $46bff87bcc38d89a$var$V(e) {
    return $46bff87bcc38d89a$var$mt() ? e instanceof Element || e instanceof $46bff87bcc38d89a$var$R(e).Element : !1;
}
function $46bff87bcc38d89a$var$j(e) {
    return $46bff87bcc38d89a$var$mt() ? e instanceof HTMLElement || e instanceof $46bff87bcc38d89a$var$R(e).HTMLElement : !1;
}
function $46bff87bcc38d89a$var$Xo(e) {
    return !$46bff87bcc38d89a$var$mt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof $46bff87bcc38d89a$var$R(e).ShadowRoot;
}
var $46bff87bcc38d89a$var$Xn = new Set([
    "inline",
    "contents"
]);
function $46bff87bcc38d89a$var$Ce(e) {
    let { overflow: o, overflowX: t, overflowY: n, display: r } = $46bff87bcc38d89a$var$W(e);
    return /auto|scroll|overlay|hidden|clip/.test(o + n + t) && !$46bff87bcc38d89a$var$Xn.has(r);
}
var $46bff87bcc38d89a$var$Jn = new Set([
    "table",
    "td",
    "th"
]);
function $46bff87bcc38d89a$var$Zo(e) {
    return $46bff87bcc38d89a$var$Jn.has($46bff87bcc38d89a$var$be(e));
}
var $46bff87bcc38d89a$var$Zn = [
    ":popover-open",
    ":modal"
];
function $46bff87bcc38d89a$var$Ue(e) {
    return $46bff87bcc38d89a$var$Zn.some((o)=>{
        try {
            return e.matches(o);
        } catch  {
            return !1;
        }
    });
}
var $46bff87bcc38d89a$var$er = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective"
], $46bff87bcc38d89a$var$tr = [
    "transform",
    "translate",
    "scale",
    "rotate",
    "perspective",
    "filter"
], $46bff87bcc38d89a$var$or = [
    "paint",
    "layout",
    "strict",
    "content"
];
function $46bff87bcc38d89a$var$ht(e) {
    let o = $46bff87bcc38d89a$var$gt(), t = $46bff87bcc38d89a$var$V(e) ? $46bff87bcc38d89a$var$W(e) : e;
    return $46bff87bcc38d89a$var$er.some((n)=>t[n] ? t[n] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !o && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !o && (t.filter ? t.filter !== "none" : !1) || $46bff87bcc38d89a$var$tr.some((n)=>(t.willChange || "").includes(n)) || $46bff87bcc38d89a$var$or.some((n)=>(t.contain || "").includes(n));
}
function $46bff87bcc38d89a$var$en(e) {
    let o = $46bff87bcc38d89a$var$ee(e);
    for(; $46bff87bcc38d89a$var$j(o) && !$46bff87bcc38d89a$var$ve(o);){
        if ($46bff87bcc38d89a$var$ht(o)) return o;
        if ($46bff87bcc38d89a$var$Ue(o)) return null;
        o = $46bff87bcc38d89a$var$ee(o);
    }
    return null;
}
function $46bff87bcc38d89a$var$gt() {
    return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var $46bff87bcc38d89a$var$nr = new Set([
    "html",
    "body",
    "#document"
]);
function $46bff87bcc38d89a$var$ve(e) {
    return $46bff87bcc38d89a$var$nr.has($46bff87bcc38d89a$var$be(e));
}
function $46bff87bcc38d89a$var$W(e) {
    return $46bff87bcc38d89a$var$R(e).getComputedStyle(e);
}
function $46bff87bcc38d89a$var$je(e) {
    return $46bff87bcc38d89a$var$V(e) ? {
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop
    } : {
        scrollLeft: e.scrollX,
        scrollTop: e.scrollY
    };
}
function $46bff87bcc38d89a$var$ee(e) {
    if ($46bff87bcc38d89a$var$be(e) === "html") return e;
    let o = e.assignedSlot || e.parentNode || $46bff87bcc38d89a$var$Xo(e) && e.host || $46bff87bcc38d89a$var$U(e);
    return $46bff87bcc38d89a$var$Xo(o) ? o.host : o;
}
function $46bff87bcc38d89a$var$tn(e) {
    let o = $46bff87bcc38d89a$var$ee(e);
    return $46bff87bcc38d89a$var$ve(o) ? e.ownerDocument ? e.ownerDocument.body : e.body : $46bff87bcc38d89a$var$j(o) && $46bff87bcc38d89a$var$Ce(o) ? o : $46bff87bcc38d89a$var$tn(o);
}
function $46bff87bcc38d89a$var$Oe(e, o, t) {
    var n;
    o === void 0 && (o = []), t === void 0 && (t = !0);
    let r = $46bff87bcc38d89a$var$tn(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = $46bff87bcc38d89a$var$R(r);
    if (i) {
        let a = $46bff87bcc38d89a$var$bt(s);
        return o.concat(s, s.visualViewport || [], $46bff87bcc38d89a$var$Ce(r) ? r : [], a && t ? $46bff87bcc38d89a$var$Oe(a) : []);
    }
    return o.concat(r, $46bff87bcc38d89a$var$Oe(r, [], t));
}
function $46bff87bcc38d89a$var$bt(e) {
    return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function $46bff87bcc38d89a$var$rn(e) {
    let o = $46bff87bcc38d89a$var$W(e), t = parseFloat(o.width) || 0, n = parseFloat(o.height) || 0, r = $46bff87bcc38d89a$var$j(e), i = r ? e.offsetWidth : t, s = r ? e.offsetHeight : n, a = $46bff87bcc38d89a$var$_e(t) !== i || $46bff87bcc38d89a$var$_e(n) !== s;
    return a && (t = i, n = s), {
        width: t,
        height: n,
        $: a
    };
}
function $46bff87bcc38d89a$var$jt(e) {
    return $46bff87bcc38d89a$var$V(e) ? e : e.contextElement;
}
function $46bff87bcc38d89a$var$De(e) {
    let o = $46bff87bcc38d89a$var$jt(e);
    if (!$46bff87bcc38d89a$var$j(o)) return $46bff87bcc38d89a$var$K(1);
    let t = o.getBoundingClientRect(), { width: n, height: r, $: i } = $46bff87bcc38d89a$var$rn(o), s = (i ? $46bff87bcc38d89a$var$_e(t.width) : t.width) / n, a = (i ? $46bff87bcc38d89a$var$_e(t.height) : t.height) / r;
    return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
        x: s,
        y: a
    };
}
var $46bff87bcc38d89a$var$rr = $46bff87bcc38d89a$var$K(0);
function $46bff87bcc38d89a$var$sn(e) {
    let o = $46bff87bcc38d89a$var$R(e);
    return !$46bff87bcc38d89a$var$gt() || !o.visualViewport ? $46bff87bcc38d89a$var$rr : {
        x: o.visualViewport.offsetLeft,
        y: o.visualViewport.offsetTop
    };
}
function $46bff87bcc38d89a$var$ir(e, o, t) {
    return o === void 0 && (o = !1), !t || o && t !== $46bff87bcc38d89a$var$R(e) ? !1 : o;
}
function $46bff87bcc38d89a$var$we(e, o, t, n) {
    o === void 0 && (o = !1), t === void 0 && (t = !1);
    let r = e.getBoundingClientRect(), i = $46bff87bcc38d89a$var$jt(e), s = $46bff87bcc38d89a$var$K(1);
    o && (n ? $46bff87bcc38d89a$var$V(n) && (s = $46bff87bcc38d89a$var$De(n)) : s = $46bff87bcc38d89a$var$De(e));
    let a = $46bff87bcc38d89a$var$ir(i, t, n) ? $46bff87bcc38d89a$var$sn(i) : $46bff87bcc38d89a$var$K(0), l = (r.left + a.x) / s.x, u = (r.top + a.y) / s.y, g = r.width / s.x, m = r.height / s.y;
    if (i) {
        let c = $46bff87bcc38d89a$var$R(i), b = n && $46bff87bcc38d89a$var$V(n) ? $46bff87bcc38d89a$var$R(n) : n, f = c, h = $46bff87bcc38d89a$var$bt(f);
        for(; h && n && b !== f;){
            let p = $46bff87bcc38d89a$var$De(h), v = h.getBoundingClientRect(), y = $46bff87bcc38d89a$var$W(h), x = v.left + (h.clientLeft + parseFloat(y.paddingLeft)) * p.x, w = v.top + (h.clientTop + parseFloat(y.paddingTop)) * p.y;
            l *= p.x, u *= p.y, g *= p.x, m *= p.y, l += x, u += w, f = $46bff87bcc38d89a$var$R(h), h = $46bff87bcc38d89a$var$bt(f);
        }
    }
    return $46bff87bcc38d89a$var$ge({
        width: g,
        height: m,
        x: l,
        y: u
    });
}
function $46bff87bcc38d89a$var$zt(e, o) {
    let t = $46bff87bcc38d89a$var$je(e).scrollLeft;
    return o ? o.left + t : $46bff87bcc38d89a$var$we($46bff87bcc38d89a$var$U(e)).left + t;
}
function $46bff87bcc38d89a$var$ln(e, o, t) {
    t === void 0 && (t = !1);
    let n = e.getBoundingClientRect(), r = n.left + o.scrollLeft - (t ? 0 : $46bff87bcc38d89a$var$zt(e, n)), i = n.top + o.scrollTop;
    return {
        x: r,
        y: i
    };
}
function $46bff87bcc38d89a$var$sr(e) {
    let { elements: o, rect: t, offsetParent: n, strategy: r } = e, i = r === "fixed", s = $46bff87bcc38d89a$var$U(n), a = o ? $46bff87bcc38d89a$var$Ue(o.floating) : !1;
    if (n === s || a && i) return t;
    let l = {
        scrollLeft: 0,
        scrollTop: 0
    }, u = $46bff87bcc38d89a$var$K(1), g = $46bff87bcc38d89a$var$K(0), m = $46bff87bcc38d89a$var$j(n);
    if ((m || !m && !i) && (($46bff87bcc38d89a$var$be(n) !== "body" || $46bff87bcc38d89a$var$Ce(s)) && (l = $46bff87bcc38d89a$var$je(n)), $46bff87bcc38d89a$var$j(n))) {
        let b = $46bff87bcc38d89a$var$we(n);
        u = $46bff87bcc38d89a$var$De(n), g.x = b.x + n.clientLeft, g.y = b.y + n.clientTop;
    }
    let c = s && !m && !i ? $46bff87bcc38d89a$var$ln(s, l, !0) : $46bff87bcc38d89a$var$K(0);
    return {
        width: t.width * u.x,
        height: t.height * u.y,
        x: t.x * u.x - l.scrollLeft * u.x + g.x + c.x,
        y: t.y * u.y - l.scrollTop * u.y + g.y + c.y
    };
}
function $46bff87bcc38d89a$var$lr(e) {
    return Array.from(e.getClientRects());
}
function $46bff87bcc38d89a$var$ar(e) {
    let o = $46bff87bcc38d89a$var$U(e), t = $46bff87bcc38d89a$var$je(e), n = e.ownerDocument.body, r = $46bff87bcc38d89a$var$Z(o.scrollWidth, o.clientWidth, n.scrollWidth, n.clientWidth), i = $46bff87bcc38d89a$var$Z(o.scrollHeight, o.clientHeight, n.scrollHeight, n.clientHeight), s = -t.scrollLeft + $46bff87bcc38d89a$var$zt(e), a = -t.scrollTop;
    return $46bff87bcc38d89a$var$W(n).direction === "rtl" && (s += $46bff87bcc38d89a$var$Z(o.clientWidth, n.clientWidth) - r), {
        width: r,
        height: i,
        x: s,
        y: a
    };
}
function $46bff87bcc38d89a$var$ur(e, o) {
    let t = $46bff87bcc38d89a$var$R(e), n = $46bff87bcc38d89a$var$U(e), r = t.visualViewport, i = n.clientWidth, s = n.clientHeight, a = 0, l = 0;
    if (r) {
        i = r.width, s = r.height;
        let u = $46bff87bcc38d89a$var$gt();
        (!u || u && o === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
    }
    return {
        width: i,
        height: s,
        x: a,
        y: l
    };
}
var $46bff87bcc38d89a$var$cr = new Set([
    "absolute",
    "fixed"
]);
function $46bff87bcc38d89a$var$fr(e, o) {
    let t = $46bff87bcc38d89a$var$we(e, !0, o === "fixed"), n = t.top + e.clientTop, r = t.left + e.clientLeft, i = $46bff87bcc38d89a$var$j(e) ? $46bff87bcc38d89a$var$De(e) : $46bff87bcc38d89a$var$K(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = r * i.x, u = n * i.y;
    return {
        width: s,
        height: a,
        x: l,
        y: u
    };
}
function $46bff87bcc38d89a$var$on(e, o, t) {
    let n;
    if (o === "viewport") n = $46bff87bcc38d89a$var$ur(e, t);
    else if (o === "document") n = $46bff87bcc38d89a$var$ar($46bff87bcc38d89a$var$U(e));
    else if ($46bff87bcc38d89a$var$V(o)) n = $46bff87bcc38d89a$var$fr(o, t);
    else {
        let r = $46bff87bcc38d89a$var$sn(e);
        n = {
            x: o.x - r.x,
            y: o.y - r.y,
            width: o.width,
            height: o.height
        };
    }
    return $46bff87bcc38d89a$var$ge(n);
}
function $46bff87bcc38d89a$var$an(e, o) {
    let t = $46bff87bcc38d89a$var$ee(e);
    return t === o || !$46bff87bcc38d89a$var$V(t) || $46bff87bcc38d89a$var$ve(t) ? !1 : $46bff87bcc38d89a$var$W(t).position === "fixed" || $46bff87bcc38d89a$var$an(t, o);
}
function $46bff87bcc38d89a$var$dr(e, o) {
    let t = o.get(e);
    if (t) return t;
    let n = $46bff87bcc38d89a$var$Oe(e, [], !1).filter((a)=>$46bff87bcc38d89a$var$V(a) && $46bff87bcc38d89a$var$be(a) !== "body"), r = null, i = $46bff87bcc38d89a$var$W(e).position === "fixed", s = i ? $46bff87bcc38d89a$var$ee(e) : e;
    for(; $46bff87bcc38d89a$var$V(s) && !$46bff87bcc38d89a$var$ve(s);){
        let a = $46bff87bcc38d89a$var$W(s), l = $46bff87bcc38d89a$var$ht(s);
        !l && a.position === "fixed" && (r = null), (i ? !l && !r : !l && a.position === "static" && !!r && $46bff87bcc38d89a$var$cr.has(r.position) || $46bff87bcc38d89a$var$Ce(s) && !l && $46bff87bcc38d89a$var$an(e, s)) ? n = n.filter((g)=>g !== s) : r = a, s = $46bff87bcc38d89a$var$ee(s);
    }
    return o.set(e, n), n;
}
function $46bff87bcc38d89a$var$pr(e) {
    let { element: o, boundary: t, rootBoundary: n, strategy: r } = e, s = [
        ...t === "clippingAncestors" ? $46bff87bcc38d89a$var$Ue(o) ? [] : $46bff87bcc38d89a$var$dr(o, this._c) : [].concat(t),
        n
    ], a = s[0], l = s.reduce((u, g)=>{
        let m = $46bff87bcc38d89a$var$on(o, g, r);
        return u.top = $46bff87bcc38d89a$var$Z(m.top, u.top), u.right = $46bff87bcc38d89a$var$ke(m.right, u.right), u.bottom = $46bff87bcc38d89a$var$ke(m.bottom, u.bottom), u.left = $46bff87bcc38d89a$var$Z(m.left, u.left), u;
    }, $46bff87bcc38d89a$var$on(o, a, r));
    return {
        width: l.right - l.left,
        height: l.bottom - l.top,
        x: l.left,
        y: l.top
    };
}
function $46bff87bcc38d89a$var$mr(e) {
    let { width: o, height: t } = $46bff87bcc38d89a$var$rn(e);
    return {
        width: o,
        height: t
    };
}
function $46bff87bcc38d89a$var$hr(e, o, t) {
    let n = $46bff87bcc38d89a$var$j(o), r = $46bff87bcc38d89a$var$U(o), i = t === "fixed", s = $46bff87bcc38d89a$var$we(e, !0, i, o), a = {
        scrollLeft: 0,
        scrollTop: 0
    }, l = $46bff87bcc38d89a$var$K(0);
    function u() {
        l.x = $46bff87bcc38d89a$var$zt(r);
    }
    if (n || !n && !i) {
        if (($46bff87bcc38d89a$var$be(o) !== "body" || $46bff87bcc38d89a$var$Ce(r)) && (a = $46bff87bcc38d89a$var$je(o)), n) {
            let b = $46bff87bcc38d89a$var$we(o, !0, i, o);
            l.x = b.x + o.clientLeft, l.y = b.y + o.clientTop;
        } else r && u();
    }
    i && !n && r && u();
    let g = r && !n && !i ? $46bff87bcc38d89a$var$ln(r, a) : $46bff87bcc38d89a$var$K(0), m = s.left + a.scrollLeft - l.x - g.x, c = s.top + a.scrollTop - l.y - g.y;
    return {
        x: m,
        y: c,
        width: s.width,
        height: s.height
    };
}
function $46bff87bcc38d89a$var$Ut(e) {
    return $46bff87bcc38d89a$var$W(e).position === "static";
}
function $46bff87bcc38d89a$var$nn(e, o) {
    if (!$46bff87bcc38d89a$var$j(e) || $46bff87bcc38d89a$var$W(e).position === "fixed") return null;
    if (o) return o(e);
    let t = e.offsetParent;
    return $46bff87bcc38d89a$var$U(e) === t && (t = t.ownerDocument.body), t;
}
function $46bff87bcc38d89a$var$un(e, o) {
    let t = $46bff87bcc38d89a$var$R(e);
    if ($46bff87bcc38d89a$var$Ue(e)) return t;
    if (!$46bff87bcc38d89a$var$j(e)) {
        let r = $46bff87bcc38d89a$var$ee(e);
        for(; r && !$46bff87bcc38d89a$var$ve(r);){
            if ($46bff87bcc38d89a$var$V(r) && !$46bff87bcc38d89a$var$Ut(r)) return r;
            r = $46bff87bcc38d89a$var$ee(r);
        }
        return t;
    }
    let n = $46bff87bcc38d89a$var$nn(e, o);
    for(; n && $46bff87bcc38d89a$var$Zo(n) && $46bff87bcc38d89a$var$Ut(n);)n = $46bff87bcc38d89a$var$nn(n, o);
    return n && $46bff87bcc38d89a$var$ve(n) && $46bff87bcc38d89a$var$Ut(n) && !$46bff87bcc38d89a$var$ht(n) ? t : n || $46bff87bcc38d89a$var$en(e) || t;
}
var $46bff87bcc38d89a$var$gr = async function(e) {
    let o = this.getOffsetParent || $46bff87bcc38d89a$var$un, t = this.getDimensions, n = await t(e.floating);
    return {
        reference: $46bff87bcc38d89a$var$hr(e.reference, await o(e.floating), e.strategy),
        floating: {
            x: 0,
            y: 0,
            width: n.width,
            height: n.height
        }
    };
};
function $46bff87bcc38d89a$var$br(e) {
    return $46bff87bcc38d89a$var$W(e).direction === "rtl";
}
var $46bff87bcc38d89a$var$Gt = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $46bff87bcc38d89a$var$sr,
    getDocumentElement: $46bff87bcc38d89a$var$U,
    getClippingRect: $46bff87bcc38d89a$var$pr,
    getOffsetParent: $46bff87bcc38d89a$var$un,
    getElementRects: $46bff87bcc38d89a$var$gr,
    getClientRects: $46bff87bcc38d89a$var$lr,
    getDimensions: $46bff87bcc38d89a$var$mr,
    getScale: $46bff87bcc38d89a$var$De,
    isElement: $46bff87bcc38d89a$var$V,
    isRTL: $46bff87bcc38d89a$var$br
};
function $46bff87bcc38d89a$var$cn(e, o) {
    return e.x === o.x && e.y === o.y && e.width === o.width && e.height === o.height;
}
function $46bff87bcc38d89a$var$vr(e, o) {
    let t = null, n, r = $46bff87bcc38d89a$var$U(e);
    function i() {
        var a;
        clearTimeout(n), (a = t) == null || a.disconnect(), t = null;
    }
    function s(a, l) {
        a === void 0 && (a = !1), l === void 0 && (l = 1), i();
        let u = e.getBoundingClientRect(), { left: g, top: m, width: c, height: b } = u;
        if (a || o(), !c || !b) return;
        let f = $46bff87bcc38d89a$var$Ke(m), h = $46bff87bcc38d89a$var$Ke(r.clientWidth - (g + c)), p = $46bff87bcc38d89a$var$Ke(r.clientHeight - (m + b)), v = $46bff87bcc38d89a$var$Ke(g), x = {
            rootMargin: -f + "px " + -h + "px " + -p + "px " + -v + "px",
            threshold: $46bff87bcc38d89a$var$Z(0, $46bff87bcc38d89a$var$ke(1, l)) || 1
        }, w = !0;
        function E(P) {
            let S = P[0].intersectionRatio;
            if (S !== l) {
                if (!w) return s();
                S ? s(!1, S) : n = setTimeout(()=>{
                    s(!1, 1e-7);
                }, 1e3);
            }
            S === 1 && !$46bff87bcc38d89a$var$cn(u, e.getBoundingClientRect()) && s(), w = !1;
        }
        try {
            t = new IntersectionObserver(E, {
                ...x,
                root: r.ownerDocument
            });
        } catch  {
            t = new IntersectionObserver(E, x);
        }
        t.observe(e);
    }
    return s(!0), i;
}
function $46bff87bcc38d89a$var$fn(e, o, t, n) {
    n === void 0 && (n = {});
    let { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: s = typeof ResizeObserver == "function", layoutShift: a = typeof IntersectionObserver == "function", animationFrame: l = !1 } = n, u = $46bff87bcc38d89a$var$jt(e), g = r || i ? [
        ...u ? $46bff87bcc38d89a$var$Oe(u) : [],
        ...$46bff87bcc38d89a$var$Oe(o)
    ] : [];
    g.forEach((v)=>{
        r && v.addEventListener("scroll", t, {
            passive: !0
        }), i && v.addEventListener("resize", t);
    });
    let m = u && a ? $46bff87bcc38d89a$var$vr(u, t) : null, c = -1, b = null;
    s && (b = new ResizeObserver((v)=>{
        let [y] = v;
        y && y.target === u && b && (b.unobserve(o), cancelAnimationFrame(c), c = requestAnimationFrame(()=>{
            var x;
            (x = b) == null || x.observe(o);
        })), t();
    }), u && !l && b.observe(u), b.observe(o));
    let f, h = l ? $46bff87bcc38d89a$var$we(e) : null;
    l && p();
    function p() {
        let v = $46bff87bcc38d89a$var$we(e);
        h && !$46bff87bcc38d89a$var$cn(h, v) && t(), h = v, f = requestAnimationFrame(p);
    }
    return t(), ()=>{
        var v;
        g.forEach((y)=>{
            r && y.removeEventListener("scroll", t), i && y.removeEventListener("resize", t);
        }), m?.(), (v = b) == null || v.disconnect(), b = null, l && cancelAnimationFrame(f);
    };
}
var $46bff87bcc38d89a$var$dn = $46bff87bcc38d89a$var$Qo, $46bff87bcc38d89a$var$pn = $46bff87bcc38d89a$var$Yo;
var $46bff87bcc38d89a$var$mn = (e, o, t)=>{
    let n = new Map, r = {
        platform: $46bff87bcc38d89a$var$Gt,
        ...t
    }, i = {
        ...r.platform,
        _c: n
    };
    return $46bff87bcc38d89a$var$Go(e, o, {
        ...r,
        platform: i
    });
};
function $46bff87bcc38d89a$var$gn(e) {
    let o = ()=>{};
    return function(n, r) {
        if (o(), !n) {
            requestAnimationFrame(()=>{
                $46bff87bcc38d89a$var$qt(e) ? $46bff87bcc38d89a$var$Ft(e, ()=>{
                    e.style.removeProperty("position");
                }) : e.style.removeProperty("position");
            });
            return;
        }
        if (!r || !e.hasAttribute("anchor")) return;
        let i = e.getAttribute("anchor"), s = e.getAttribute("anchor-strategy") || "absolute";
        s !== "absolute" && s !== "fixed" && (console.warn(`[createAnchorUpdater] Invalid anchor strategy "${s}" for element:`, e), s = "absolute"), o = $46bff87bcc38d89a$var$fn(r, e, ()=>{
            let a = $46bff87bcc38d89a$var$hn(window.getComputedStyle(e).getPropertyValue("--anchor-gap"), e), l = $46bff87bcc38d89a$var$hn(window.getComputedStyle(e).getPropertyValue("--anchor-offset"), e), u = i.split(" ")[0], g = {};
            switch(u){
                case "top":
                case "bottom":
                    g = {
                        top: a,
                        left: -1 * l,
                        right: l,
                        bottom: a
                    };
                    break;
                case "left":
                case "right":
                    g = {
                        top: -1 * l,
                        bottom: l,
                        left: a,
                        right: a
                    };
                    break;
            }
            $46bff87bcc38d89a$var$mn(r, e, {
                strategy: s,
                placement: i.replace(" ", "-"),
                middleware: [
                    $46bff87bcc38d89a$var$pn({
                        padding: g
                    }),
                    $46bff87bcc38d89a$var$dn({
                        padding: g
                    })
                ]
            }).then(async ({ x: m, y: c, placement: b })=>{
                if (!$46bff87bcc38d89a$var$wr() && s === "absolute") {
                    let p = null;
                    for(let v = e.parentElement; v; v = v.parentElement){
                        let y = getComputedStyle(v).position;
                        if (y === "relative" || y === "absolute" || y === "fixed" || y === "sticky") {
                            p = v;
                            break;
                        }
                    }
                    if (p) {
                        let v = p.getBoundingClientRect();
                        m -= v.left + window.scrollX, c -= v.top + window.scrollY;
                    }
                }
                let f = `${m}px`, h = `${c}px`;
                switch(b.split("-")[0]){
                    case "top":
                        h = `calc(${c}px - var(--anchor-gap, 0px))`, f = `calc(${m}px + var(--anchor-offset, 0px))`;
                        break;
                    case "right":
                        f = `calc(${m}px + var(--anchor-gap, 0px))`, h = `calc(${c}px + var(--anchor-offset, 0px))`;
                        break;
                    case "bottom":
                        h = `calc(${c}px + var(--anchor-gap, 0px))`, f = `calc(${m}px + var(--anchor-offset, 0px))`;
                        break;
                    case "left":
                        f = `calc(${m}px - var(--anchor-gap, 0px))`, h = `calc(${c}px + var(--anchor-offset, 0px))`;
                        break;
                }
                {
                    let p = e.getBoundingClientRect();
                    if (p.x === 0 && p.y === 0 && p.width === 0 && p.height === 0) return;
                }
                Object.assign(e.style, {
                    left: f,
                    top: h,
                    position: s
                }), await $46bff87bcc38d89a$var$Gt.isRTL?.(e) && Object.assign(e.style, {
                    right: "unset",
                    bottom: "unset"
                });
            });
        });
    };
}
function $46bff87bcc38d89a$var$wr() {
    return "showPopover" in HTMLElement.prototype && HTMLElement.prototype.showPopover.toString().includes("[native code]");
}
function $46bff87bcc38d89a$var$hn(e, o) {
    let t = document.createElement("div");
    o.appendChild(t), t.style.setProperty("margin-top", "0px", "important"), t.style.setProperty("margin-top", e, "important");
    let n = parseFloat(window.getComputedStyle(t).marginTop) || 0;
    return o.removeChild(t), n;
}
function $46bff87bcc38d89a$var$ze(e) {
    return $46bff87bcc38d89a$var$Yt(e) && "tabIndex" in e;
}
function $46bff87bcc38d89a$var$Yt(e) {
    return $46bff87bcc38d89a$var$yr(e) && "tagName" in e;
}
function $46bff87bcc38d89a$var$Qt(e) {
    return $46bff87bcc38d89a$var$Yt(e) && "accessKey" in e;
}
function $46bff87bcc38d89a$var$yr(e) {
    return typeof e != "object" || e === null ? !1 : "nodeType" in e;
}
function $46bff87bcc38d89a$var$bn(e) {
    return $46bff87bcc38d89a$var$Yt(e) && "style" in e;
}
function $46bff87bcc38d89a$var$vn(e) {
    return $46bff87bcc38d89a$var$Qt(e) && e.nodeName === "INPUT";
}
function $46bff87bcc38d89a$var$B(e) {
    let o = e.getBoundingClientRect();
    return !(!(o.x !== 0 || o.y !== 0 || o.width !== 0 || o.height !== 0) || (e.ownerDocument.defaultView || window).getComputedStyle(e).visibility === "hidden");
}
var $46bff87bcc38d89a$var$wn = {
    get selectRequired () {
        let e = document.createElement("select");
        e.setAttribute("required", "true");
        let o = e.validationMessage;
        return Object.defineProperty(this, "selectRequired", {
            value: o
        }), o;
    }
};
function $46bff87bcc38d89a$var$Ge(e, o, t) {
    function n() {
        if (!$46bff87bcc38d89a$var$B(e)) {
            for (let r of e.children)if ($46bff87bcc38d89a$var$B(r)) return;
            t();
        }
    }
    if (typeof ResizeObserver < "u") {
        let r = new ResizeObserver(n);
        r.observe(e), o.addEventListener("abort", ()=>r.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
        let r = new IntersectionObserver(n);
        r.observe(e), o.addEventListener("abort", ()=>r.disconnect());
    }
}
var $46bff87bcc38d89a$var$ae = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
function $46bff87bcc38d89a$var$Y(e, o, t) {
    let n = o ? e.indexOf(o) : null;
    switch(n === -1 && (n = null), t){
        case 0:
            for(let r = 0; r < e.length; r++)if ($46bff87bcc38d89a$var$B(e[r])) return e[r];
            return null;
        case 1:
            for(let r = e.length - 1; r >= 0; r--)if ($46bff87bcc38d89a$var$B(e[r])) return e[r];
            return null;
        case 2:
            if (n === null) return $46bff87bcc38d89a$var$Y(e, o, 1);
            for(let r = n - 1; r >= 0; r--)if ($46bff87bcc38d89a$var$B(e[r])) return e[r];
            return null;
        case 3:
            if (n === null) return $46bff87bcc38d89a$var$Y(e, o, 0);
            for(let r = n + 1; r < e.length; r++)if ($46bff87bcc38d89a$var$B(e[r])) return e[r];
            return null;
        case 4:
            return null;
    }
}
var $46bff87bcc38d89a$var$N = [];
$46bff87bcc38d89a$var$ut(()=>{
    function e(o) {
        if (o.target === document.body || $46bff87bcc38d89a$var$N[0] === o.target) return;
        let t = o.target;
        t && "closest" in t && (t = t.closest($46bff87bcc38d89a$var$ae), $46bff87bcc38d89a$var$N.unshift(t ?? o.target), $46bff87bcc38d89a$var$N = $46bff87bcc38d89a$var$N.filter((n)=>n != null && n.isConnected), $46bff87bcc38d89a$var$N.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("pointerdown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("pointerdown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});
var $46bff87bcc38d89a$var$Ye = !1, $46bff87bcc38d89a$var$Xt = !1;
typeof navigator < "u" && ($46bff87bcc38d89a$var$Ye = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), $46bff87bcc38d89a$var$Xt = navigator.userAgent.toLowerCase().includes("firefox"));
var $46bff87bcc38d89a$var$Jt = !1;
function $46bff87bcc38d89a$var$Me(e, o, t, n, r, i) {
    $46bff87bcc38d89a$var$Ar(e.ownerDocument);
    let s = $46bff87bcc38d89a$var$Pe(e), a = $46bff87bcc38d89a$var$gn(e), l = $46bff87bcc38d89a$var$J();
    e.hasAttribute("popover") || e.setAttribute("popover", "");
    let u = t();
    for (let c of u)c.setAttribute("type", "button"), c.setAttribute("aria-haspopup", "true"), c.setAttribute("aria-controls", e.id), c.setAttribute("aria-expanded", "false");
    e.hasAttribute("open") && queueMicrotask(()=>e.showPopover());
    function g() {
        e.hasAttribute("open") && e.hidePopover();
    }
    let m = new AbortController;
    o.addEventListener("abort", ()=>m.abort()), e.addEventListener("beforetoggle", (c)=>{
        let b = $46bff87bcc38d89a$var$vt(c, u);
        a(c.newState === "open", n?.() ?? b), c.newState === "open" ? b && ($46bff87bcc38d89a$var$Ge(b, m.signal, g), $46bff87bcc38d89a$var$Ge(e, m.signal, g)) : (m.abort(), m = new AbortController);
        let f = e.hasAttribute("open");
        c.newState === "open" && !f ? e.setAttributeNoCallbacks("open", "") : c.newState === "closed" && f && e.removeAttributeNoCallbacks("open"), c.newState === "open" ? (b?.setAttribute("aria-expanded", "true"), b?.id && e.setAttribute("aria-labelledby", b.id), r?.(), $46bff87bcc38d89a$var$Jt = e.getAttribute("popover") === "") : (b?.setAttribute("aria-expanded", "false"), e.removeAttribute("aria-labelledby"), i?.(), $46bff87bcc38d89a$var$Jt = !1), c.oldState === "closed" && c.newState === "open" ? ($46bff87bcc38d89a$var$Ye && (l.dispose(), l = $46bff87bcc38d89a$var$J()), s.start("in")) : c.oldState === "open" && c.newState === "closed" && ($46bff87bcc38d89a$var$Ye && l.style(e, "transition-property", "none"), s.start("out"));
    }, {
        signal: o
    }), o.addEventListener("abort", ()=>s.abort());
}
function $46bff87bcc38d89a$var$vt(e, o) {
    return e.source ?? $46bff87bcc38d89a$var$N.find((t)=>o.includes(t)) ?? o[0] ?? null;
}
var $46bff87bcc38d89a$var$yn = new WeakSet;
function $46bff87bcc38d89a$var$Ar(e) {
    if ($46bff87bcc38d89a$var$Xt || $46bff87bcc38d89a$var$Ye || $46bff87bcc38d89a$var$yn.has(e)) return;
    $46bff87bcc38d89a$var$yn.add(e);
    let o = null;
    e.addEventListener("mousedown", ()=>{
        $46bff87bcc38d89a$var$Jt && (e.body.setAttribute("tabindex", "-1"), o && clearTimeout(o), o = setTimeout(()=>e.body.removeAttribute("tabindex")));
    }, {
        capture: !0
    });
}
function $46bff87bcc38d89a$var$z(e, o, t, n) {
    function r() {
        let a = e.getBoundingClientRect();
        n.style.setProperty(o, a.width + "px");
    }
    let i = e.ownerDocument, s = new ResizeObserver(r);
    s.observe(e), i.addEventListener("transitionend", r, {
        signal: t
    }), t.addEventListener("abort", ()=>s.disconnect());
}
var $46bff87bcc38d89a$var$xr = 0;
function $46bff87bcc38d89a$var$k(e) {
    return `${e}-${$46bff87bcc38d89a$var$xr++}`;
}
var $46bff87bcc38d89a$var$Tr = 200;
function $46bff87bcc38d89a$var$ue(e, o, t, n) {
    $46bff87bcc38d89a$var$Sr(), e.addEventListener(o, (r)=>{
        $46bff87bcc38d89a$var$Zt !== null && Date.now() - $46bff87bcc38d89a$var$Zt < $46bff87bcc38d89a$var$Tr || n(r);
    }, {
        passive: !0,
        signal: t
    });
}
var $46bff87bcc38d89a$var$Zt = null, $46bff87bcc38d89a$var$An = !1;
function $46bff87bcc38d89a$var$Sr() {
    $46bff87bcc38d89a$var$An || ($46bff87bcc38d89a$var$An = !0, document.addEventListener("keydown", ()=>{
        $46bff87bcc38d89a$var$Zt = Date.now();
    }, {
        capture: !0
    }));
}
var $46bff87bcc38d89a$var$wt = class extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let n = super.get(t);
        return n === void 0 && (n = this.factory(t, this), this.set(t, n)), n;
    }
};
var $46bff87bcc38d89a$var$xn = new $46bff87bcc38d89a$var$wt(()=>({
        referenceCounter: 0,
        d: $46bff87bcc38d89a$var$J()
    }));
function $46bff87bcc38d89a$var$yt(e) {
    let o = $46bff87bcc38d89a$var$xn.get(e);
    if (o.referenceCounter++, o.referenceCounter === 1) {
        let n = [
            $46bff87bcc38d89a$var$kr(),
            $46bff87bcc38d89a$var$Ir(),
            $46bff87bcc38d89a$var$Lr()
        ];
        n.forEach(({ before: r })=>r({
                doc: e,
                d: o.d
            })), n.forEach(({ after: r })=>r({
                doc: e,
                d: o.d
            }));
    }
    let t = !1;
    return ()=>{
        t || (t = !0, o.referenceCounter--, !(o.referenceCounter > 0) && (o.d.dispose(), $46bff87bcc38d89a$var$xn.delete(e)));
    };
}
function $46bff87bcc38d89a$var$Lr() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        },
        after () {}
    };
}
function $46bff87bcc38d89a$var$Ir() {
    let e;
    return {
        before ({ doc: o }) {
            let t = o.documentElement, n = o.defaultView ?? window;
            e = Math.max(0, n.innerWidth - t.clientWidth), t.style.setProperty("--el-top-layer-scrollbar-offset", "0px");
        },
        after ({ doc: o, d: t }) {
            let n = o.documentElement, r = Math.max(0, n.clientWidth - n.offsetWidth), i = Math.max(0, e - r);
            t.style(n, "paddingRight", `${i}px`), t.add(()=>{
                n.style.setProperty("--el-top-layer-scrollbar-offset", `-${i}px`);
            });
        }
    };
}
function $46bff87bcc38d89a$var$Pr() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $46bff87bcc38d89a$var$kr() {
    return $46bff87bcc38d89a$var$Pr() ? {
        before ({ doc: e, d: o }) {
            function t(n) {
                return !!n.closest("[popover], dialog > *");
            }
            o.microTask(()=>{
                if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
                    let i = $46bff87bcc38d89a$var$J();
                    i.style(e.documentElement, "scrollBehavior", "auto"), o.add(()=>o.microTask(()=>i.dispose()));
                }
                let n = window.scrollY ?? window.pageYOffset, r = null;
                o.addEventListener(e, "click", (i)=>{
                    if ($46bff87bcc38d89a$var$ze(i.target)) try {
                        let s = i.target.closest("a");
                        if (!s) return;
                        let { hash: a } = new URL(s.href), l = e.querySelector(a);
                        $46bff87bcc38d89a$var$ze(l) && !t(l) && (r = l);
                    } catch  {}
                }, !0), o.addEventListener(e, "touchstart", (i)=>{
                    if ($46bff87bcc38d89a$var$ze(i.target) && $46bff87bcc38d89a$var$bn(i.target)) {
                        if (t(i.target)) {
                            let s = i.target;
                            for(; s.parentElement && t(s.parentElement);)s = s.parentElement;
                            o.style(s, "overscrollBehavior", "contain");
                        } else o.style(i.target, "touchAction", "none");
                    }
                }), o.addEventListener(e, "touchmove", (i)=>{
                    if ($46bff87bcc38d89a$var$ze(i.target)) {
                        if ($46bff87bcc38d89a$var$vn(i.target)) return;
                        if (t(i.target)) {
                            let s = i.target;
                            for(; s.parentElement && s.dataset.tailwindplusPortal !== "" && !(s.scrollHeight > s.clientHeight || s.scrollWidth > s.clientWidth);)s = s.parentElement;
                            s.dataset.tailwindplusPortal === "" && i.preventDefault();
                        } else i.preventDefault();
                    }
                }, {
                    passive: !1
                }), o.add(()=>{
                    let i = window.scrollY ?? window.pageYOffset;
                    n !== i && window.scrollTo(0, n), r && r.isConnected && (r.scrollIntoView({
                        block: "nearest"
                    }), r = null);
                });
            });
        },
        after () {}
    } : {
        before () {},
        after () {}
    };
}
function $46bff87bcc38d89a$var$Et(e, o) {
    let t = null;
    e.addEventListener("toggle", (n)=>{
        n.newState === "open" ? t || (t = $46bff87bcc38d89a$var$yt(e.ownerDocument)) : t && (t(), t = null);
    }, {
        signal: o
    }), o.addEventListener("abort", ()=>{
        t && (t(), t = null);
    });
}
var $46bff87bcc38d89a$var$Tn = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $46bff87bcc38d89a$var$At(e) {
    let o = e.innerText ?? "", t = e.cloneNode(!0);
    if (!$46bff87bcc38d89a$var$Qt(t)) return o;
    let n = !1;
    for (let i of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))i.remove(), n = !0;
    let r = n ? t.innerText ?? "" : o;
    return $46bff87bcc38d89a$var$Tn.test(r) && (r = r.replace($46bff87bcc38d89a$var$Tn, "")), r;
}
function $46bff87bcc38d89a$var$Sn(e) {
    let o = e.getAttribute("aria-label");
    if (typeof o == "string") return o.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let n = t.split(" ").map((r)=>{
            let i = document.getElementById(r);
            if (i) {
                let s = i.getAttribute("aria-label");
                return typeof s == "string" ? s.trim() : $46bff87bcc38d89a$var$At(i).trim();
            }
            return null;
        }).filter(Boolean);
        if (n.length > 0) return n.join(", ");
    }
    return $46bff87bcc38d89a$var$At(e).trim();
}
var $46bff87bcc38d89a$var$F, $46bff87bcc38d89a$var$Qe, $46bff87bcc38d89a$var$eo = class extends $46bff87bcc38d89a$var$A {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$F, []);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Qe, null);
    }
    mount(t) {
        let n = this.getInput(), r = this.getButton(), i = this.getOptions();
        n.id || (n.id = $46bff87bcc38d89a$var$k("autocomplete-input")), r && (r.id || (r.id = $46bff87bcc38d89a$var$k("autocomplete-button"))), i.id || (i.id = $46bff87bcc38d89a$var$k("autocomplete-listbox")), $46bff87bcc38d89a$var$Me(i, t, ()=>{
            let c = this.getButton();
            return c ? [
                c
            ] : [];
        }, ()=>this.getInput(), ()=>this.onBeforeOpen(), ()=>this.onBeforeClose()), $46bff87bcc38d89a$var$Et(i, t), n.setAttribute("role", "combobox"), n.setAttribute("aria-autocomplete", "list"), n.setAttribute("aria-expanded", "false"), n.setAttribute("aria-controls", i.id), n.setAttribute("aria-activedescendant", ""), n.setAttribute("autocomplete", "off"), r && (r.setAttribute("type", "button"), r.setAttribute("tabindex", "-1"), r.setAttribute("aria-expanded", "false"), r.setAttribute("aria-haspopup", "listbox"), r.setAttribute("popovertarget", i.id)), i.setAttribute("role", "listbox"), i.setAttribute("popover", "manual");
        let s = this, a = new WeakSet;
        function l() {
            for (let c of i.getItems())a.has(c) || (a.add(c), c.id || (c.id = $46bff87bcc38d89a$var$k("option")), c.setAttribute("role", "option"), c.setAttribute("aria-selected", "false"), c.setAttribute("tabIndex", "-1"), c.addEventListener("mousedown", (b)=>{
                b.button === 0 && (b.preventDefault(), s.selectOption(c));
            }, {
                signal: t
            }), $46bff87bcc38d89a$var$ue(c, "mouseover", t, ()=>s.setActiveItem(c, !1)), $46bff87bcc38d89a$var$ue(c, "mouseout", t, ()=>s.clearActiveItem()));
            s.filterOptions();
        }
        l();
        let u = new MutationObserver(l);
        u.observe(this, {
            attributes: !1,
            childList: !0,
            subtree: !0
        }), r && $46bff87bcc38d89a$var$z(r, "--button-width", t, this), $46bff87bcc38d89a$var$z(n, "--input-width", t, this), n.addEventListener("input", ()=>{
            n.matches(":disabled") || (this.filterOptions(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length > 0 ? i.hasAttribute("open") || i.showPopover() : i.hidePopover());
        }, {
            signal: t
        });
        let g = ()=>{
            n.matches(":disabled") || (n.focus(), i.hasAttribute("open") ? i.hidePopover() : (this.filterOptions(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length > 0 && i.showPopover()));
        };
        n.addEventListener("pointerdown", g, {
            signal: t
        }), r && (r.addEventListener("pointerdown", (c)=>{
            c.preventDefault(), g();
        }, {
            signal: t
        }), r.addEventListener("click", (c)=>{
            c.preventDefault(), c.stopImmediatePropagation();
        }, {
            signal: t
        })), n.addEventListener("blur", ({ relatedTarget: c })=>{
            c && this.contains(c) || i.hidePopover();
        }, {
            signal: t
        }), n.addEventListener("keydown", (c)=>{
            if (!n.matches(":disabled")) switch(c.key){
                case "ArrowDown":
                    c.preventDefault(), i.hasAttribute("open") || ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length === 0 && this.filterOptions(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length > 0 && i.showPopover()), this.goToItem(3);
                    break;
                case "ArrowUp":
                    c.preventDefault(), i.hasAttribute("open") || ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length === 0 && this.filterOptions(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length > 0 && i.showPopover()), this.goToItem(2);
                    break;
                case "Home":
                case "PageUp":
                    return i.hasAttribute("open") ? (c.preventDefault(), c.stopPropagation(), this.goToItem(0)) : void 0;
                case "End":
                case "PageDown":
                    return i.hasAttribute("open") ? (c.preventDefault(), c.stopPropagation(), this.goToItem(1)) : void 0;
                case "Enter":
                    {
                        let b = this.getActiveItem();
                        b && (c.preventDefault(), this.selectOption(b)), i.hasAttribute("open") && (c.preventDefault(), i.hidePopover());
                        break;
                    }
                case "Escape":
                    if (!i.hasAttribute("open")) return;
                    c.preventDefault(), i.hidePopover();
                    break;
                case "Tab":
                    i.hidePopover();
                    break;
            }
        }, {
            signal: t
        });
        let m = Array.from(i.querySelectorAll("el-option[disabled]"));
        for (let c of m)c.setAttribute("aria-disabled", "true"), c.setAttribute("aria-selected", "false");
        t.addEventListener("abort", ()=>{
            u.disconnect();
        });
    }
    getInput() {
        let t = this.querySelector("input");
        if (!t) throw new Error("`<el-autocomplete>` must contain an input element.");
        return t;
    }
    getButton() {
        return this.querySelector("button");
    }
    getOptions() {
        let t = this.querySelector("el-options");
        if (!t) throw new Error("`<el-autocomplete>` must contain a `<el-options>` element.");
        return t;
    }
    filterOptions() {
        let t = this.getInput().value.toLowerCase();
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Qe) !== t && (this.clearActiveItem(), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Qe, t)), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$F, []);
        for (let n of this.getOptions().getItems()){
            let r = n.getAttribute("value")?.toLowerCase() || "", i = $46bff87bcc38d89a$var$At(n)?.trim().toLowerCase() ?? "";
            t === "" || r.includes(t) || i.includes(t) ? ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).push(n), n.removeAttribute("hidden"), n.removeAttribute("aria-hidden")) : (n.setAttribute("hidden", ""), n.setAttribute("aria-hidden", "true"));
        }
    }
    getActiveItem() {
        let n = this.getInput().getAttribute("aria-activedescendant");
        return n ? document.getElementById(n) : null;
    }
    goToItem(t) {
        if ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F).length === 0) return;
        let n = this.getActiveItem(), r = $46bff87bcc38d89a$var$Y($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$F), n, t);
        r && this.setActiveItem(r);
    }
    setActiveItem(t, n = !0) {
        let r = this.getInput(), i = this.getActiveItem();
        i !== null && i.setAttribute("aria-selected", "false"), t.setAttribute("aria-selected", "true"), r.setAttribute("aria-activedescendant", t.id), n && t.scrollIntoView({
            block: "nearest"
        });
    }
    clearActiveItem() {
        let t = this.getInput(), n = this.getActiveItem();
        n !== null && n.setAttribute("aria-selected", "false"), t.setAttribute("aria-activedescendant", "");
    }
    selectOption(t) {
        let n = this.getInput(), r = t.getAttribute("value");
        r && (n.value = r, n.dispatchEvent(new Event("input", {
            bubbles: !0,
            cancelable: !0
        })), n.dispatchEvent(new Event("change", {
            bubbles: !0,
            cancelable: !0
        })), this.getOptions().hidePopover());
    }
    onBeforeOpen() {
        let t = this.getInput(), n = this.getButton();
        t.setAttribute("aria-expanded", "true"), n?.setAttribute("aria-expanded", "true");
    }
    onBeforeClose() {
        let t = this.getInput(), n = this.getButton();
        t.setAttribute("aria-expanded", "false"), n?.setAttribute("aria-expanded", "false"), this.clearActiveItem();
    }
};
$46bff87bcc38d89a$var$F = new WeakMap, $46bff87bcc38d89a$var$Qe = new WeakMap;
$46bff87bcc38d89a$var$T("el-autocomplete", $46bff87bcc38d89a$var$eo);
var $46bff87bcc38d89a$var$G, $46bff87bcc38d89a$var$Xe, $46bff87bcc38d89a$var$Je, $46bff87bcc38d89a$var$te, $46bff87bcc38d89a$var$xt, $46bff87bcc38d89a$var$no, $46bff87bcc38d89a$var$oo = class extends $46bff87bcc38d89a$var$A {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$te);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$G, []);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Xe, null);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Je, ({ query: t, content: n })=>n.toLocaleLowerCase().includes(t.toLocaleLowerCase().trim()));
    }
    mount(t) {
        let n = this.getInput(), r = this.getItems();
        n.id || (n.id = $46bff87bcc38d89a$var$k("command-input")), r.id || (r.id = $46bff87bcc38d89a$var$k("command-items")), n.setAttribute("role", "combobox"), n.setAttribute("aria-autocomplete", "list"), n.setAttribute("autocomplete", "off"), n.setAttribute("aria-controls", r.id), r.setAttribute("role", "listbox");
        let i = this, s = new WeakSet;
        function a(u = !1) {
            var g;
            for (let m of r.getItems())s.has(m) || (s.add(m), m.id || (m.id = $46bff87bcc38d89a$var$k("item")), m.setAttribute("role", "option"), m.setAttribute("tabIndex", "-1"), m.setAttribute("aria-selected", "false"), m.hasAttribute("disabled") && m.setAttribute("aria-disabled", "true"), $46bff87bcc38d89a$var$ue(m, "mouseover", t, ()=>{
                var c;
                return $46bff87bcc38d89a$var$H(c = i, $46bff87bcc38d89a$var$te, $46bff87bcc38d89a$var$no).call(c, m, !1);
            }));
            $46bff87bcc38d89a$var$H(g = i, $46bff87bcc38d89a$var$te, $46bff87bcc38d89a$var$xt).call(g, u), u || i.goToItem(0);
        }
        a(!0);
        let l = new MutationObserver(()=>a(!1));
        l.observe(this, {
            attributes: !1,
            childList: !0,
            subtree: !0
        }), $46bff87bcc38d89a$var$z(n, "--input-width", t, this), n.addEventListener("input", ()=>$46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$te, $46bff87bcc38d89a$var$xt).call(this), {
            signal: t
        }), n.addEventListener("keydown", (u)=>{
            switch(u.key){
                case "ArrowDown":
                    u.preventDefault(), this.goToItem(3);
                    break;
                case "ArrowUp":
                    u.preventDefault(), this.goToItem(2);
                    break;
                case "Home":
                case "PageUp":
                    return u.preventDefault(), u.stopPropagation(), this.goToItem(0);
                case "End":
                case "PageDown":
                    return u.preventDefault(), u.stopPropagation(), this.goToItem(1);
                case "Enter":
                    {
                        let g = this.getActiveItem();
                        g && (u.preventDefault(), g.click());
                        break;
                    }
                case "Tab":
                    break;
            }
        }, {
            signal: t
        }), t.addEventListener("abort", ()=>{
            l.disconnect();
        });
    }
    getInput() {
        let t = this.querySelector("input");
        if (!t) throw new Error("`<el-command-palette>` must contain an input element.");
        return t;
    }
    getItems() {
        let t = this.querySelector("el-command-list");
        if (!t) throw new Error("`<el-command-palette>` must contain a `<el-command-list>` element.");
        return t;
    }
    getGroups() {
        return this.getItems().querySelectorAll("el-command-group");
    }
    getSuggestions() {
        return this.querySelector("el-defaults");
    }
    getActiveItem() {
        let n = this.getInput().getAttribute("aria-activedescendant");
        return n ? document.getElementById(n) : null;
    }
    goToItem(t) {
        if ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$G).length === 0) return;
        let n = this.getActiveItem(), r = $46bff87bcc38d89a$var$Y($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$G), n, t);
        r && $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$te, $46bff87bcc38d89a$var$no).call(this, r);
    }
    clearActiveItem() {
        let t = this.getInput(), n = this.getActiveItem();
        if (n !== null) {
            n.setAttribute("aria-selected", "false");
            let r = this.querySelector(`el-command-preview[for="${n.id}"]`);
            r && r.setAttribute("hidden", "");
        }
        t.removeAttribute("aria-activedescendant"), this.dispatchEvent(new CustomEvent("change", {
            detail: {
                relatedTarget: null
            },
            bubbles: !1,
            cancelable: !1
        }));
    }
    reset() {
        let t = this.getInput();
        t.value = "", t.dispatchEvent(new Event("input", {
            bubbles: !0,
            cancelable: !0
        })), t.dispatchEvent(new Event("change", {
            bubbles: !0,
            cancelable: !0
        })), $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$te, $46bff87bcc38d89a$var$xt).call(this, !0), this.clearActiveItem();
    }
    setFilterCallback(t) {
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Je, t);
    }
};
$46bff87bcc38d89a$var$G = new WeakMap, $46bff87bcc38d89a$var$Xe = new WeakMap, $46bff87bcc38d89a$var$Je = new WeakMap, $46bff87bcc38d89a$var$te = new WeakSet, $46bff87bcc38d89a$var$xt = function(t = !1) {
    let n = this.getItems(), r = this.getInput().value ?? "";
    $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$G, []);
    for (let a of n.getItems()){
        if (a.closest("el-defaults")) continue;
        let l = $46bff87bcc38d89a$var$Sn(a) ?? "";
        r === "" || !$46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Je).call(this, {
            query: r,
            node: a,
            content: l
        }) ? (a.setAttribute("hidden", ""), a.setAttribute("aria-hidden", "true")) : ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$G).push(a), a.removeAttribute("hidden"), a.removeAttribute("aria-hidden"));
    }
    for (let a of this.getGroups())a.getItems().some((u)=>!u.hasAttribute("hidden")) ? a.removeAttribute("hidden") : a.setAttribute("hidden", "");
    let i = this.getSuggestions();
    i && (r === "" ? (i.removeAttribute("hidden"), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$G, i.getItems())) : i.setAttribute("hidden", ""));
    let s = this.querySelector("el-no-results");
    s && (r === "" || $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$G).length > 0 ? s.setAttribute("hidden", "") : s.removeAttribute("hidden")), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$G).length === 0 ? n.setAttribute("hidden", "") : n.removeAttribute("hidden"), !(t && r === "") && ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$G).length === 0 ? this.clearActiveItem() : $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Xe) !== r && this.goToItem(0), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Xe, r));
}, $46bff87bcc38d89a$var$no = function(t, n = !0) {
    let r = this.getInput(), i = this.getActiveItem();
    if (t === i) return;
    if (i !== null) {
        i.setAttribute("aria-selected", "false");
        let a = this.querySelector(`el-command-preview[for="${i.id}"]`);
        a && a.setAttribute("hidden", "");
    }
    t.setAttribute("aria-selected", "true"), r.setAttribute("aria-activedescendant", t.id);
    let s = this.querySelector(`el-command-preview[for="${t.id}"]`);
    s && s.removeAttribute("hidden"), n && t.scrollIntoView({
        block: "nearest"
    }), this.dispatchEvent(new CustomEvent("change", {
        detail: {
            relatedTarget: t
        },
        bubbles: !1,
        cancelable: !1
    }));
};
var $46bff87bcc38d89a$var$ro = class extends $46bff87bcc38d89a$var$A {
    getItems() {
        return Array.from(this.querySelectorAll(`${$46bff87bcc38d89a$var$ae},[role="option"]`));
    }
}, $46bff87bcc38d89a$var$io = class extends $46bff87bcc38d89a$var$A {
    getItems() {
        return Array.from(this.querySelectorAll(`${$46bff87bcc38d89a$var$ae},[role="option"]`));
    }
}, $46bff87bcc38d89a$var$so = class extends $46bff87bcc38d89a$var$A {
}, $46bff87bcc38d89a$var$lo = class extends $46bff87bcc38d89a$var$A {
}, $46bff87bcc38d89a$var$ao = class extends $46bff87bcc38d89a$var$A {
    getItems() {
        return Array.from(this.querySelectorAll(`${$46bff87bcc38d89a$var$ae},[role="option"]`));
    }
};
$46bff87bcc38d89a$var$T("el-command-palette", $46bff87bcc38d89a$var$oo);
$46bff87bcc38d89a$var$T("el-command-list", $46bff87bcc38d89a$var$ro);
$46bff87bcc38d89a$var$T("el-defaults", $46bff87bcc38d89a$var$io);
$46bff87bcc38d89a$var$T("el-no-results", $46bff87bcc38d89a$var$so);
$46bff87bcc38d89a$var$T("el-command-group", $46bff87bcc38d89a$var$ao);
$46bff87bcc38d89a$var$T("el-command-preview", $46bff87bcc38d89a$var$lo);
var $46bff87bcc38d89a$var$He = null;
typeof globalThis.window < "u" && ($46bff87bcc38d89a$var$He = HTMLDialogElement.prototype.close, Object.defineProperties(HTMLDialogElement.prototype, {
    close: {
        value () {
            let e = this.closest("el-dialog");
            if (!(e instanceof $46bff87bcc38d89a$var$Re)) return $46bff87bcc38d89a$var$He?.apply(this, arguments);
            let o = e.beforeClose();
            if (o === !0) return $46bff87bcc38d89a$var$He?.apply(this, arguments);
            o !== !1 && o.then((t)=>t ? $46bff87bcc38d89a$var$He?.apply(this, arguments) : null).catch(console.error);
        }
    }
}), document.addEventListener("command", (e)=>{
    let o = e.target;
    if (!(o instanceof HTMLDialogElement) || !("command" in e) || e.command !== "close") return;
    let t = o.closest("el-dialog");
    if (!(t instanceof $46bff87bcc38d89a$var$Re)) return;
    let n = t.beforeClose();
    n !== !0 && (e.stopImmediatePropagation(), e.preventDefault(), n !== !1 && n.then((r)=>r ? $46bff87bcc38d89a$var$He?.apply(o) : null).catch(console.error));
}, !0));
var $46bff87bcc38d89a$var$Q, $46bff87bcc38d89a$var$oe, $46bff87bcc38d89a$var$Be, $46bff87bcc38d89a$var$ye, $46bff87bcc38d89a$var$Ze, $46bff87bcc38d89a$var$uo, $46bff87bcc38d89a$var$Re = class extends $46bff87bcc38d89a$var$A {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Ze);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Q, null);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$oe, null);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Be, !0);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$ye, $46bff87bcc38d89a$var$Pe(this, ()=>Array.from(this.querySelectorAll("el-dialog-panel,el-dialog-backdrop"))));
    }
    mount(t) {
        let n = this.getNativeDialog();
        n.removeAttribute("open"), n.style.setProperty("right", "var(--el-top-layer-scrollbar-offset, 0px)");
        let r = this.hasAttribute("open");
        for (let a of $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$Ze, $46bff87bcc38d89a$var$uo).call(this))a.setAttribute("aria-expanded", r.toString());
        $46bff87bcc38d89a$var$Cr(n, t, (a)=>{
            a.preventDefault();
            let l = new Event("cancel", {
                bubbles: !1,
                cancelable: !0
            });
            !this.dispatchEvent(l) || n.close();
        });
        let i = this.querySelector("el-dialog-panel");
        $46bff87bcc38d89a$var$Ge(i ?? n, t, ()=>{
            this.hasAttribute("open") && n.close();
        });
        let s = null;
        n.addEventListener("beforetoggle", (a)=>{
            let l = a;
            l.newState === "open" && l.oldState === "closed" && this.beforeOpen();
            let u = this.hasAttribute("open");
            if (l.newState === "open" && !u ? (this.dispatchEvent(new CustomEvent("open", {
                bubbles: !1,
                cancelable: !1
            })), this.setAttribute("open", "")) : l.newState === "closed" && u && (this.dispatchEvent(new CustomEvent("close", {
                bubbles: !1,
                cancelable: !1
            })), this.removeAttribute("open")), l.newState === "open" && l.oldState === "closed") $46bff87bcc38d89a$var$N.length > 0 && !s && (s = $46bff87bcc38d89a$var$N[0]);
            else if (l.newState === "closed" && l.oldState === "open") {
                let g = $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Be);
                setTimeout(()=>{
                    if (!g) {
                        s && s === document.activeElement && s.isConnected && "blur" in s && typeof s.blur == "function" && s.blur();
                        return;
                    }
                    s && s !== document.activeElement && s.isConnected && $46bff87bcc38d89a$var$Le(s), s = null;
                });
            }
        }, {
            signal: t
        }), n.addEventListener("focusout", (a)=>{
            a.relatedTarget === null && queueMicrotask(()=>{
                n.contains(n.ownerDocument.activeElement) || n.focus();
            });
        }, {
            signal: t
        }), t.addEventListener("abort", ()=>{
            var a;
            $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ye).abort(), (a = $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$oe)) == null || a.call(this);
        }), this.hasAttribute("open") && n.showModal();
    }
    onAttributeChange(t, n, r) {
        switch(t){
            case "open":
                {
                    let i = this.getNativeDialog();
                    for (let s of $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$Ze, $46bff87bcc38d89a$var$uo).call(this))s.setAttribute("aria-expanded", r !== null ? "true" : "false");
                    r === null ? i.close() : i.showModal();
                    break;
                }
        }
    }
    getNativeDialog() {
        let t = this.querySelector("dialog");
        if (!t) throw new Error("[ElDialog] No `<dialog>` element found");
        return t;
    }
    beforeOpen() {
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Be, !0), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Q) && ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Q).abort(), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Q, null)), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$oe) || $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$oe, $46bff87bcc38d89a$var$yt(this.ownerDocument)), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ye) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ye).start("in");
    }
    beforeClose() {
        if ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$oe) && ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$oe).call(this), $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$oe, null)), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Q)) return !1;
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Q, new AbortController);
        let t = $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Q).signal;
        return new Promise((n)=>{
            $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ye)?.start("out", ()=>{
                t.aborted || ($46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Q, null), requestAnimationFrame(()=>{
                    let r = this.getNativeDialog(), i = r.style.cssText;
                    r.style.cssText = i + "transition-duration: 0 !important;", $46bff87bcc38d89a$var$He?.apply(r), requestAnimationFrame(()=>{
                        r.style.cssText = i;
                    });
                }), n(!0));
            });
        });
    }
    show() {
        this.getNativeDialog().showModal();
    }
    hide({ restoreFocus: t = !0 } = {}) {
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Be, t), this.getNativeDialog().close();
    }
};
$46bff87bcc38d89a$var$Q = new WeakMap, $46bff87bcc38d89a$var$oe = new WeakMap, $46bff87bcc38d89a$var$Be = new WeakMap, $46bff87bcc38d89a$var$ye = new WeakMap, $46bff87bcc38d89a$var$Ze = new WeakSet, $46bff87bcc38d89a$var$uo = function() {
    return document.querySelectorAll(`[commandfor="${this.getNativeDialog().id}"]`);
}, $46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$Re, "observedAttributes", [
    "open"
]);
var $46bff87bcc38d89a$var$co = class extends $46bff87bcc38d89a$var$A {
    mount(o) {
        $46bff87bcc38d89a$var$Or(this, o, ()=>{
            let t = this.getDialog(), n = t.getNativeDialog();
            if (!n.hasAttribute("open")) return;
            let r = new Event("cancel", {
                bubbles: !1,
                cancelable: !0
            });
            !t.dispatchEvent(r) || n.close();
        });
    }
    getDialog() {
        let o = this.closest("el-dialog");
        if (!o) throw new Error("[ElDialogPanel] No `<el-dialog>` parent found");
        return o;
    }
}, $46bff87bcc38d89a$var$fo = class extends $46bff87bcc38d89a$var$A {
    mount() {
        this.setAttribute("inert", "");
    }
};
$46bff87bcc38d89a$var$T("el-dialog", $46bff87bcc38d89a$var$Re);
$46bff87bcc38d89a$var$T("el-dialog-panel", $46bff87bcc38d89a$var$co);
$46bff87bcc38d89a$var$T("el-dialog-backdrop", $46bff87bcc38d89a$var$fo);
function $46bff87bcc38d89a$var$Or(e, o, t) {
    let n = null;
    document.addEventListener("pointerdown", (r)=>{
        n = r.composedPath()[0] || r.target;
    }, !0), document.addEventListener("click", (r)=>{
        if (n !== r.target) return;
        if (r.target === e) {
            let { clientX: s, clientY: a } = r, l = e.getBoundingClientRect();
            if (s >= l.left && s <= l.right && a >= l.top && a <= l.bottom) return;
            t(r);
            return;
        }
        let i = e.closest("dialog");
        if (i && i.contains(r.target) && !e.contains(r.target)) {
            t(r);
            return;
        }
        if (r.target === r.target.ownerDocument.documentElement) {
            t(r);
            return;
        }
    }, {
        signal: o,
        capture: !0
    });
}
function $46bff87bcc38d89a$var$Cr(e, o, t) {
    e.addEventListener("keydown", (n)=>{
        n.key === "Escape" && (n.defaultPrevented || t(n));
    }, {
        signal: o
    });
}
var $46bff87bcc38d89a$var$Ne, $46bff87bcc38d89a$var$et, $46bff87bcc38d89a$var$po, $46bff87bcc38d89a$var$Tt = class extends $46bff87bcc38d89a$var$A {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$et);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Ne, $46bff87bcc38d89a$var$Pe(this));
    }
    mount(t) {
        this.id || (this.id = $46bff87bcc38d89a$var$k("disclosure")), this.hasAttribute("hidden") ? this.removeAttributeNoCallbacks("open") : this.setAttributeNoCallbacks("open", "");
        let n = !this.hasAttribute("hidden");
        for (let r of $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$et, $46bff87bcc38d89a$var$po).call(this))r.setAttribute("aria-expanded", n.toString()), r.setAttribute("aria-controls", this.id);
        this.addEventListener("command", (r)=>{
            if (r.target instanceof HTMLElement && "command" in r) switch(r.command){
                case "--show":
                    this.show(), r.preventDefault();
                    break;
                case "--hide":
                    this.hide(), r.preventDefault();
                    break;
                case "--toggle":
                    this.toggle(), r.preventDefault();
                    break;
            }
        }, {
            signal: t
        }), t.addEventListener("abort", ()=>$46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ne).abort());
    }
    onAttributeChange(t, n, r) {
        switch(t){
            case "hidden":
                r === null ? this.setAttributeNoCallbacks("open", "") : this.removeAttributeNoCallbacks("open");
                for (let i of $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$et, $46bff87bcc38d89a$var$po).call(this))i.setAttribute("aria-expanded", r === null ? "true" : "false");
                r === null ? $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ne).start("in") : $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ne).start("out");
                break;
            case "open":
                r === null ? this.hide() : this.show();
                break;
        }
    }
    show() {
        this.removeAttribute("hidden");
    }
    hide() {
        this.setAttribute("hidden", "");
    }
    toggle() {
        this.hasAttribute("hidden") ? this.show() : this.hide();
    }
};
$46bff87bcc38d89a$var$Ne = new WeakMap, $46bff87bcc38d89a$var$et = new WeakSet, $46bff87bcc38d89a$var$po = function() {
    return document.querySelectorAll(`[commandfor="${this.id}"]`);
}, $46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$Tt, "observedAttributes", [
    "hidden",
    "open"
]);
$46bff87bcc38d89a$var$T("el-disclosure", $46bff87bcc38d89a$var$Tt);
function $46bff87bcc38d89a$var$St(e, o, t, n, r) {
    let i = null;
    for (let a of o)a.addEventListener("pointerdown", (l)=>{
        l.button === 0 && e.classList.contains(":popover-open") && (i = Date.now() + 100);
    }, {
        signal: n,
        capture: !0
    });
    e.ownerDocument.addEventListener("focusin", (a)=>{
        if (!t.hasAttribute("open")) return;
        let l = a.target, u = a.relatedTarget;
        l !== null && (i && Date.now() < i || e.contains(l) || o.some((g)=>g.contains(l)) || r(u));
    }, {
        signal: n
    });
}
var $46bff87bcc38d89a$var$Dr = 200;
function $46bff87bcc38d89a$var$Lt(e, o, t) {
    let n = null, r = "", i = null, s = null;
    e.id || (e.id = $46bff87bcc38d89a$var$k(o.role));
    let a = o.getButton();
    a.id || (a.id = $46bff87bcc38d89a$var$k(`${o.role}-button`)), $46bff87bcc38d89a$var$Me(e, t, ()=>[
            o.getButton()
        ], ()=>o.getButton(), ()=>o.onBeforeOpen(), ()=>{
        o.onBeforeClose(), h(), r = "", i && (clearTimeout(i), i = null);
    }), $46bff87bcc38d89a$var$Et(e, t), e.setAttribute("popover", "manual"), e.setAttribute("role", o.role), a.setAttribute("popovertarget", e.id), a.setAttribute("aria-haspopup", o.role);
    let l = new WeakSet;
    function u() {
        let w = o.getItems(), E = {
            passive: !0,
            signal: t
        }, P = o.role === "menu" ? "menuitem" : "option";
        for (let S of w)l.has(S) || (l.add(S), S.id || (S.id = $46bff87bcc38d89a$var$k("item")), S.setAttribute("role", P), S.setAttribute("tabIndex", "-1"), S.addEventListener("click", ()=>o.onItemClick(S), E), $46bff87bcc38d89a$var$ue(S, "mouseover", t, ()=>f(S, !1)), $46bff87bcc38d89a$var$ue(S, "mouseout", t, ()=>h()));
    }
    u();
    let g = new MutationObserver(u);
    g.observe(e, {
        attributes: !1,
        childList: !0,
        subtree: !0
    }), $46bff87bcc38d89a$var$St(e, [
        a
    ], e, t, (w)=>{
        w === null && (s = Date.now() + 100), e.hidePopover();
    });
    let m = null, c = !1;
    a.addEventListener("pointerdown", (w)=>{
        if (w.button === 0 && !a.matches(":disabled")) {
            if (w.pointerType === "touch") {
                c = !0;
                return;
            }
            e.togglePopover(), m = Date.now();
        }
    }, {
        signal: t
    }), document.addEventListener("pointerup", (w)=>{
        if (w.button !== 0 || a.matches(":disabled") || !e.hasAttribute("open")) return;
        if (Date.now() - (m ?? 0) > $46bff87bcc38d89a$var$Dr) {
            let P = w.composedPath();
            if (P.includes(e)) {
                if (m !== null) {
                    let S = p();
                    S && S.click();
                }
                return;
            }
            for (let S of P){
                if (!(S instanceof Element)) continue;
                if ((S.getAttribute("commandfor") || S.getAttribute("popovertarget")) === e.id) return;
            }
            e.hidePopover();
        }
        m = null;
    }, {
        signal: t,
        capture: !0
    }), a.addEventListener("click", (w)=>{
        if (c) {
            c = !1;
            return;
        }
        w.preventDefault(), w.stopPropagation();
    }, {
        signal: t
    });
    let b = null;
    e.addEventListener("beforetoggle", (w)=>{
        let E = w;
        E.newState === "open" && E.oldState === "closed" && $46bff87bcc38d89a$var$N.length > 0 && !b && (b = $46bff87bcc38d89a$var$N[0]);
    }, {
        signal: t
    }), e.addEventListener("toggle", (w)=>{
        let E = w;
        E.newState === "closed" && E.oldState === "open" && setTimeout(()=>{
            !e.contains(document.activeElement) && document.activeElement !== document.body || s && Date.now() < s || (b && b !== document.activeElement && b.isConnected && $46bff87bcc38d89a$var$Le(b), b = null);
        });
    }, {
        signal: t
    }), t.addEventListener("abort", ()=>{
        i && (clearTimeout(i), i = null), g.disconnect();
    });
    function f(w, E = !0) {
        let P = p();
        P !== null && P.setAttribute("tabIndex", "-1"), e.removeAttribute("tabIndex"), w.setAttribute("tabIndex", "0"), w.focus({
            preventScroll: !0
        }), n = w, E && w.scrollIntoView({
            block: "nearest"
        });
    }
    function h() {
        let w = p();
        w !== null && w.setAttribute("tabIndex", "-1"), n = null, e.hasAttribute("open") && (e.setAttribute("tabIndex", "0"), e.focus());
    }
    function p() {
        return n;
    }
    function v(w, E = !1) {
        if (w === "") return null;
        let P = o.getItems(), S = w.toLowerCase(), $ = p(), re = $ ? P.indexOf($) : -1;
        if (!E && $ && re !== -1 && $46bff87bcc38d89a$var$B($) && ($.textContent?.trim().toLowerCase() || "").startsWith(S)) return $;
        for(let D = re + 1; D < P.length; D++)if ((P[D].textContent?.trim().toLowerCase() || "").startsWith(S) && $46bff87bcc38d89a$var$B(P[D])) return P[D];
        for(let D = 0; D <= re; D++)if ((P[D].textContent?.trim().toLowerCase() || "").startsWith(S) && $46bff87bcc38d89a$var$B(P[D])) return P[D];
        return null;
    }
    function y(w) {
        let E = r === "";
        i && (clearTimeout(i), i = null), r += w.toLowerCase();
        let P = v(r, E);
        P && f(P, !0), i = setTimeout(()=>{
            r = "", i = null;
        }, 350);
    }
    function x() {
        return r !== "";
    }
    return {
        ignoreNextFocusRestoration: ()=>s = Date.now() + 100,
        setActiveItem: f,
        clearActiveItem: h,
        getActiveItem: p,
        findItemBySearchQuery: v,
        handleSearchKey: y,
        hasActiveSearchQuery: x
    };
}
var $46bff87bcc38d89a$var$ne, $46bff87bcc38d89a$var$Ee, $46bff87bcc38d89a$var$O, $46bff87bcc38d89a$var$ot, $46bff87bcc38d89a$var$mo, $46bff87bcc38d89a$var$tt = class extends $46bff87bcc38d89a$var$A {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$ot);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$ne, this.attachInternals());
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$Ee, "");
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$O, null);
    }
    mount(t) {
        let n = this.getOptions();
        this.value = this.getAttribute("value") ?? this.value ?? "";
        let r = this.getButton();
        r.id || (r.id = $46bff87bcc38d89a$var$k("select-button")), $46bff87bcc38d89a$var$z(r, "--button-width", t, this), r.addEventListener("keydown", (s)=>{
            if (!r.matches(":disabled")) switch(s.key){
                case "ArrowUp":
                    n.showPopover(), this.goToItem("selected"), s.preventDefault();
                    break;
                case "ArrowDown":
                    n.showPopover(), this.goToItem("selected"), s.preventDefault();
                    break;
                case "Enter":
                    s.preventDefault(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ne).form && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ne).form.requestSubmit();
                    break;
                case " ":
                    if (n.hasAttribute("open") && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).hasActiveSearchQuery()) {
                        s.preventDefault(), s.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).handleSearchKey(s.key);
                        break;
                    }
                    s.preventDefault(), n.hasAttribute("open") ? n.hidePopover() : (n.showPopover(), this.goToItem("selected"));
                    break;
                default:
                    n.hasAttribute("open") && s.key.length === 1 && !s.ctrlKey && !s.altKey && !s.metaKey && (s.preventDefault(), s.stopPropagation(), this.handleSearchKey(s.key));
                    break;
            }
        }, {
            signal: t
        });
        for (let s of $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ne).labels)s.setAttribute("for", r.id);
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$O, $46bff87bcc38d89a$var$Lt(n, {
            role: "listbox",
            getItems: ()=>this.getItems(),
            onItemClick: (s)=>this.setSelectedOption(s),
            getButton: ()=>this.getButton(),
            onBeforeOpen: ()=>this.onBeforeOpen(),
            onBeforeClose: ()=>this.onBeforeClose()
        }, t)), n.addEventListener("keydown", (s)=>{
            switch(s.key){
                case "ArrowDown":
                    return s.preventDefault(), s.stopPropagation(), this.goToItem(3);
                case "ArrowUp":
                    return s.preventDefault(), s.stopPropagation(), this.goToItem(2);
                case "Home":
                case "PageUp":
                    return s.preventDefault(), s.stopPropagation(), this.goToItem(0);
                case "End":
                case "PageDown":
                    return s.preventDefault(), s.stopPropagation(), this.goToItem(1);
                case " ":
                    if ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).hasActiveSearchQuery()) {
                        s.preventDefault(), s.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).handleSearchKey(s.key);
                        return;
                    }
                case "Enter":
                    {
                        s.preventDefault(), s.stopPropagation();
                        let a = this.getActiveItem();
                        a ? a.click() : n.hidePopover();
                        return;
                    }
                case "Tab":
                    $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).ignoreNextFocusRestoration();
                    break;
                case "Escape":
                    s.preventDefault(), s.stopPropagation(), n.hidePopover(), r.focus();
                    break;
                default:
                    s.key.length === 1 && !s.ctrlKey && !s.altKey && !s.metaKey && (s.preventDefault(), s.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).handleSearchKey(s.key));
                    break;
            }
        }, {
            signal: t
        }), n.addEventListener("toggle", (s)=>{
            s.newState === "open" && this.onOpen();
        }, {
            signal: t
        });
        let i = Array.from(n.querySelectorAll("el-option[disabled]"));
        for (let s of i)s.setAttribute("aria-disabled", "true"), s.setAttribute("aria-selected", "false");
    }
    onAttributeChange(t, n, r) {
        switch(t){
            case "value":
                r !== null && (this.value = r);
                break;
            case "required":
                $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$ot, $46bff87bcc38d89a$var$mo).call(this);
                break;
        }
    }
    getButton() {
        let t = this.querySelector("button");
        if (!t) throw new Error("`<el-select>` must contain a button element.");
        return t;
    }
    getOptions() {
        let t = this.querySelector("el-options");
        if (!t) throw new Error("`<el-select>` must contain a `<el-options>` element.");
        return t;
    }
    setSelectedOption(t) {
        this.value = t.getAttribute("value"), this.dispatchEvent(new Event("input", {
            bubbles: !0,
            cancelable: !0
        })), this.dispatchEvent(new Event("change", {
            bubbles: !0,
            cancelable: !0
        })), this.getOptions().hidePopover();
    }
    getOptionByName(t) {
        return this.getOptions().getOptionByName(t);
    }
    getItems() {
        return this.getOptions().getItems();
    }
    getActiveItem() {
        return $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O)?.getActiveItem();
    }
    getSelectedOption() {
        return this.getOptionByName($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ee));
    }
    goToItem(t = 4) {
        let n = this.getItems();
        if (n.length === 0) return;
        let r = this.getActiveItem();
        if (r === null && (t === 2 || t === 3)) {
            this.goToItem("selected");
            return;
        }
        if (t === "selected") {
            let s = this.getSelectedOption();
            s && $46bff87bcc38d89a$var$B(s) ? this.setActiveItem(s) : this.goToItem(0);
            return;
        }
        let i = $46bff87bcc38d89a$var$Y(n, r, t);
        i && this.setActiveItem(i);
    }
    setActiveItem(t) {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).setActiveItem(t);
    }
    clearActiveItem() {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).clearActiveItem();
    }
    onBeforeOpen() {
        let t = this.getButton(), n = t.dataset.originalTabIndex;
        n && (t.dataset.originalTabIndex = n), t.setAttribute("tabIndex", "-1");
    }
    onOpen() {
        this.getActiveItem() === null && this.goToItem("selected");
    }
    onBeforeClose() {
        let t = this.getButton(), n = t.dataset.originalTabIndex;
        delete t.dataset.originalTabIndex, n !== void 0 ? t.setAttribute("tabIndex", n) : t.removeAttribute("tabIndex");
        let r = this.getActiveItem();
        r !== null && r.setAttribute("tabIndex", "-1");
    }
    handleSearchKey(t) {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$O).handleSearchKey(t);
    }
    set value(t) {
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$Ee, t), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ne).setFormValue(t), $46bff87bcc38d89a$var$H(this, $46bff87bcc38d89a$var$ot, $46bff87bcc38d89a$var$mo).call(this);
        let n = this.getSelectedOption();
        if (n) {
            for (let r of this.getItems())r.setAttribute("aria-selected", "false");
            n.setAttribute("aria-selected", "true");
            try {
                this.querySelectorAll("el-selectedcontent").forEach((r)=>r.update());
            } catch  {}
        }
    }
    get value() {
        return $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ee);
    }
};
$46bff87bcc38d89a$var$ne = new WeakMap, $46bff87bcc38d89a$var$Ee = new WeakMap, $46bff87bcc38d89a$var$O = new WeakMap, $46bff87bcc38d89a$var$ot = new WeakSet, $46bff87bcc38d89a$var$mo = function() {
    if (!this.hasAttribute("required") || $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$Ee)) {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ne).setValidity({});
        return;
    }
    $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$ne).setValidity({
        valueMissing: !0
    }, $46bff87bcc38d89a$var$wn.selectRequired, this.getButton());
}, $46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$tt, "formAssociated", !0), $46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$tt, "observedAttributes", [
    "required"
]);
var $46bff87bcc38d89a$var$ho = class extends $46bff87bcc38d89a$var$A {
    mount() {
        this.update();
    }
    update() {
        let t = this.getSelect().getSelectedOption();
        if (!t) return;
        let n = document.createDocumentFragment();
        for (let r of t.childNodes)n.append(r.cloneNode(!0));
        this.replaceChildren(n);
    }
    getSelect() {
        let o = this.closest("el-select");
        if (!o) throw new Error("`<el-selectedcontent>` must be inside of a `<el-select>` element.");
        return o;
    }
};
$46bff87bcc38d89a$var$T("el-select", $46bff87bcc38d89a$var$tt);
$46bff87bcc38d89a$var$T("el-selectedcontent", $46bff87bcc38d89a$var$ho);
var $46bff87bcc38d89a$var$go = class extends $46bff87bcc38d89a$var$A {
    getButton() {
        let o = this.querySelector("button");
        if (!o) throw new Error("[ElDropdown] No `<button>` element found");
        return o;
    }
    mount(o) {
        let t = this.getButton();
        t.id || (t.id = $46bff87bcc38d89a$var$k("dropdown-button")), $46bff87bcc38d89a$var$z(t, "--button-width", o, this);
        let n = this.querySelectorAll("label");
        for (let r of n)r.setAttribute("for", t.id);
    }
}, $46bff87bcc38d89a$var$C, $46bff87bcc38d89a$var$It = class extends $46bff87bcc38d89a$var$A {
    constructor(){
        super(...arguments);
        $46bff87bcc38d89a$var$L(this, $46bff87bcc38d89a$var$C, null);
    }
    mount(t) {
        $46bff87bcc38d89a$var$I(this, $46bff87bcc38d89a$var$C, $46bff87bcc38d89a$var$Lt(this, {
            role: "menu",
            getItems: ()=>this.getItems(),
            onItemClick: ()=>this.hidePopover(),
            getButton: ()=>this.getDropdown().getButton(),
            onBeforeOpen: ()=>this.onBeforeOpen(),
            onBeforeClose: ()=>this.onBeforeClose()
        }, t));
        let r = this.getDropdown().getButton();
        r.addEventListener("keydown", (i)=>{
            if (!r.disabled) switch(i.key){
                case "ArrowDown":
                    this.showPopover(), this.goToItem(0), i.preventDefault();
                    break;
                case "ArrowUp":
                    this.showPopover(), this.goToItem(1), i.preventDefault();
                    break;
                case " ":
                    if (this.hasAttribute("open") && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).hasActiveSearchQuery()) {
                        i.preventDefault(), i.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).handleSearchKey(i.key);
                        break;
                    }
                case "Enter":
                    i.preventDefault(), this.hasAttribute("open") ? this.hidePopover() : (this.showPopover(), this.goToItem(0));
                    break;
                default:
                    this.hasAttribute("open") && i.key.length === 1 && !i.ctrlKey && !i.altKey && !i.metaKey && (i.preventDefault(), i.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).handleSearchKey(i.key));
                    break;
            }
        }, {
            signal: t
        }), this.addEventListener("keydown", (i)=>{
            switch(i.key){
                case "ArrowDown":
                    return i.preventDefault(), i.stopPropagation(), this.goToItem(3);
                case "ArrowUp":
                    return i.preventDefault(), i.stopPropagation(), this.goToItem(2);
                case "Home":
                case "PageUp":
                    return i.preventDefault(), i.stopPropagation(), this.goToItem(0);
                case "End":
                case "PageDown":
                    return i.preventDefault(), i.stopPropagation(), this.goToItem(1);
                case " ":
                    if ($46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).hasActiveSearchQuery()) {
                        i.preventDefault(), i.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).handleSearchKey(i.key);
                        return;
                    }
                case "Enter":
                    {
                        i.preventDefault(), i.stopPropagation();
                        let s = this.getActiveItem();
                        s ? s.click() : this.hidePopover();
                        return;
                    }
                case "Tab":
                    $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).ignoreNextFocusRestoration();
                    break;
                case "Escape":
                    i.preventDefault(), i.stopPropagation(), this.hidePopover(), r.focus();
                    break;
                default:
                    i.key.length === 1 && !i.ctrlKey && !i.altKey && !i.metaKey && (i.preventDefault(), i.stopPropagation(), $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).handleSearchKey(i.key));
                    break;
            }
        }, {
            signal: t
        });
    }
    onBeforeOpen() {
        let n = this.getDropdown().getButton(), r = n.dataset.originalTabIndex;
        r && (n.dataset.originalTabIndex = r), n.setAttribute("tabIndex", "-1"), this.getActiveItem() === null && (this.setAttribute("tabIndex", "0"), setTimeout(()=>this.focus({
                preventScroll: !0
            })));
    }
    onBeforeClose() {
        let n = this.getDropdown().getButton(), r = n.dataset.originalTabIndex;
        delete n.dataset.originalTabIndex, r !== void 0 ? n.setAttribute("tabIndex", r) : n.removeAttribute("tabIndex");
        let i = this.getActiveItem();
        i !== null && i.setAttribute("tabIndex", "-1");
    }
    goToItem(t = 4) {
        let n = this.getItems();
        if (n.length === 0) return;
        let r = this.getActiveItem(), i = $46bff87bcc38d89a$var$Y(n, r, t);
        i && this.setActiveItem(i);
    }
    setActiveItem(t) {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).setActiveItem(t);
    }
    clearActiveItem() {
        $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C) && $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C).clearActiveItem();
    }
    getDropdown() {
        let t = this.closest("el-dropdown");
        if (!t) throw new Error("[ElMenu] No `<el-dropdown>` element found");
        return t;
    }
    getItems() {
        return Array.from(this.querySelectorAll(`${$46bff87bcc38d89a$var$ae},[role="menuitem"]`));
    }
    getActiveItem() {
        return $46bff87bcc38d89a$var$d(this, $46bff87bcc38d89a$var$C)?.getActiveItem() || null;
    }
    onAttributeChange(t, n, r) {
        switch(t){
            case "open":
                r === null ? this.hidePopover() : this.showPopover();
                break;
        }
    }
};
$46bff87bcc38d89a$var$C = new WeakMap, $46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$It, "observedAttributes", [
    "anchor",
    "open"
]);
$46bff87bcc38d89a$var$T("el-menu", $46bff87bcc38d89a$var$It);
$46bff87bcc38d89a$var$T("el-dropdown", $46bff87bcc38d89a$var$go);
var $46bff87bcc38d89a$var$Pt = class extends $46bff87bcc38d89a$var$A {
    onAttributeChange(o, t, n) {
        switch(o){
            case "open":
                n === null ? this.hidePopover() : this.showPopover();
                break;
        }
    }
    getOptionByName(o) {
        let t = this.querySelector(`el-option[value="${o}"]`);
        return t || null;
    }
    getItems() {
        return Array.from(this.querySelectorAll("el-option:not([disabled])"));
    }
};
$46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$Pt, "observedAttributes", [
    "anchor",
    "open"
]);
var $46bff87bcc38d89a$var$bo = class extends $46bff87bcc38d89a$var$A {
};
$46bff87bcc38d89a$var$T("el-options", $46bff87bcc38d89a$var$Pt);
$46bff87bcc38d89a$var$T("el-option", $46bff87bcc38d89a$var$bo);
var $46bff87bcc38d89a$var$vo = class extends $46bff87bcc38d89a$var$A {
    getPopovers() {
        return Array.from(this.querySelectorAll("* > el-popover"));
    }
}, $46bff87bcc38d89a$var$kt = class extends $46bff87bcc38d89a$var$A {
    mount(o) {
        if (!this.id) throw new Error("[ElPopover] No id found for popover (ensure `id` is set)");
        let n = this.getButtons();
        for (let a of n)a.id || (a.id = $46bff87bcc38d89a$var$k("popover-button")), a.addEventListener("keydown", (l)=>{
            (l.key === "Enter" || l.key === " ") && (l.preventDefault(), this.togglePopover());
        }, {
            signal: o
        });
        $46bff87bcc38d89a$var$Me(this, o, ()=>this.getButtons()), this.setAttribute("tabindex", "-1");
        let r = this, i = this.closest("el-popover-group");
        i && i.getPopovers().includes(this) && (r = i), $46bff87bcc38d89a$var$St(r, n, this, o, ()=>this.hidePopover());
        let s = new AbortController;
        o.addEventListener("abort", ()=>s.abort()), this.addEventListener("beforetoggle", (a)=>{
            if (a.newState === "open") {
                let l = $46bff87bcc38d89a$var$vt(a, n);
                l && $46bff87bcc38d89a$var$z(l, "--button-width", s.signal, this);
            } else s.abort(), s = new AbortController;
        }), this.addEventListener("toggle", (a)=>{
            a.newState === "closed" && a.oldState === "open" && setTimeout(()=>{
                if (!this.contains(document.activeElement) && document.activeElement !== document.body) return;
                let l = $46bff87bcc38d89a$var$vt(a, n);
                l && l !== document.activeElement && l.isConnected && $46bff87bcc38d89a$var$Le(l);
            });
        }, {
            signal: o
        });
    }
    getButtons() {
        let o = this.id, t = Array.from(document.querySelectorAll(`[popovertarget="${o}"]`));
        if (!t) throw new Error('[ElPopover] No button found for popover (ensure you add a `<button popovertarget="${id}">` on the page)');
        return t;
    }
    onAttributeChange(o, t, n) {
        switch(o){
            case "open":
                n === null ? this.hidePopover() : this.showPopover();
                break;
        }
    }
};
$46bff87bcc38d89a$var$M($46bff87bcc38d89a$var$kt, "observedAttributes", [
    "anchor",
    "open"
]);
$46bff87bcc38d89a$var$T("el-popover", $46bff87bcc38d89a$var$kt);
$46bff87bcc38d89a$var$T("el-popover-group", $46bff87bcc38d89a$var$vo);
var $46bff87bcc38d89a$var$wo = class extends $46bff87bcc38d89a$var$A {
    mount(o) {
        let t = this.getList(), n = this.getPanels(), r = t.getTabButtons(), i = n.getPanels();
        if (r.length !== i.length) {
            console.warn("[ElTabGroup] Mismatch between number of tabs and panels");
            return;
        }
        for(let a = 0; a < i.length; a++){
            let l = i[a], u = r[a];
            u.id || (u.id = $46bff87bcc38d89a$var$k("tailwindplus-tab")), l.id || (l.id = $46bff87bcc38d89a$var$k("tailwindplus-tab-panel")), l.setAttribute("aria-labelledby", u.id), u.setAttribute("aria-controls", l.id), u.setAttribute("role", "tab");
        }
        let s = this.getActiveTab();
        s === -1 && (s = 0), t.setActiveTab(s), n.setActivePanel(s), t.addEventListener("keydown", (a)=>{
            switch(a.key){
                case "ArrowLeft":
                    {
                        a.preventDefault();
                        let u = this.getActiveTab() - 1;
                        u < 0 && (u = r.length - 1), this.setActiveTab(u), r[u].focus();
                        break;
                    }
                case "ArrowRight":
                    {
                        a.preventDefault();
                        let u = this.getActiveTab() + 1;
                        u >= r.length && (u = 0), this.setActiveTab(u), r[u].focus();
                        break;
                    }
                case "Home":
                case "PageUp":
                    a.preventDefault(), this.setActiveTab(0), r[0].focus();
                    break;
                case "End":
                case "PageDown":
                    a.preventDefault(), this.setActiveTab(r.length - 1), r[r.length - 1].focus();
                    break;
            }
        }, {
            signal: o
        });
        for(let a = 0; a < r.length; a++)r[a].addEventListener("click", (u)=>{
            u.preventDefault(), this.setActiveTab(a);
        }, {
            signal: o
        });
    }
    getActiveTab() {
        let o = this.querySelector("el-tab-panels"), t = o.getPanels().find((n)=>!n.hasAttribute("hidden"));
        return t ? o.getPanels().indexOf(t) : -1;
    }
    getList() {
        let o = this.querySelector("el-tab-list");
        if (!o) throw new Error("[ElTabGroup] No `<el-tab-list>` element found");
        return o;
    }
    getPanels() {
        let o = this.querySelector("el-tab-panels");
        if (!o) throw new Error("[ElTabGroup] No `<el-tab-panels>` element found");
        return o;
    }
    setActiveTab(o) {
        if (this.getActiveTab() === o) return;
        let n = this.getList(), r = this.getPanels(), i = n.getTabButtons();
        o < 0 || o >= i.length || (n.setActiveTab(o), r.setActivePanel(o));
    }
}, $46bff87bcc38d89a$var$yo = class extends $46bff87bcc38d89a$var$A {
    mount() {
        this.setAttribute("role", "tablist"), this.setAttribute("aria-orientation", "horizontal");
    }
    getTabButtons() {
        let o = this.querySelectorAll("button");
        return Array.from(o);
    }
    setActiveTab(o) {
        this.getTabButtons().forEach((n, r)=>{
            let i = r === o;
            n.setAttribute("tabindex", i ? "0" : "-1"), n.setAttribute("aria-selected", i ? "true" : "false");
        });
    }
}, $46bff87bcc38d89a$var$Eo = class extends $46bff87bcc38d89a$var$A {
    mount() {
        let t = this.getTabGroup().getList(), n = this.getPanels(), r = new MutationObserver((i)=>{
            for (let s of i){
                let a = s.target;
                switch(s.attributeName){
                    case "hidden":
                        if (!a.hasAttribute(s.attributeName)) {
                            let l = n.indexOf(a);
                            t.setActiveTab(l), this.setActivePanel(l);
                        }
                }
            }
        });
        for (let i of n)i.setAttribute("role", "tabpanel"), i.setAttribute("tabindex", "0"), r.observe(i, {
            attributeFilter: [
                "hidden"
            ],
            attributes: !0
        });
    }
    getTabGroup() {
        let o = this.closest("el-tab-group");
        if (!o) throw new Error("`<el-tab-panels>` must be inside of a `<el-tab-group>` element.");
        return o;
    }
    getPanels() {
        return Array.from(this.children);
    }
    setActivePanel(o) {
        this.getPanels().forEach((n, r)=>{
            n.toggleAttribute("hidden", r !== o);
        });
    }
};
$46bff87bcc38d89a$var$T("el-tab-list", $46bff87bcc38d89a$var$yo);
$46bff87bcc38d89a$var$T("el-tab-panels", $46bff87bcc38d89a$var$Eo);
$46bff87bcc38d89a$var$T("el-tab-group", $46bff87bcc38d89a$var$wo);
typeof globalThis.window < "u" && setTimeout(()=>window.dispatchEvent(new Event("elements:ready")));




//# sourceMappingURL=index.a79f8e6c.js.map
